var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAward2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 423,
    height: 580,
    viewBox: "0 0 423 580",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_637_1031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.016 118.987C128.416 119.096 129.824 119.184 131.265 119.254C137.638 119.591 140.873 119.005 142.758 125.781C143.971 130.119 145.693 134.304 140.871 136.539C130.469 141.367 112.518 137.716 102.661 133.223C96.8593 130.578 91.5289 126.629 88.4308 120.926C84.4953 113.674 87.9253 105.176 83.8083 98.1076C80.2539 91.9724 71.0969 99.3211 71.5869 89.4079C71.854 84.0221 77.9724 83.6513 80.3679 79.6399C88.5371 65.9797 68.5536 57.7494 58.1419 62.1679C47.0561 66.8717 43.7246 79.7073 42.7835 91.0182C41.4691 106.844 44.6579 120.797 49.9468 135.406C56.27 152.893 69.0151 172.124 73.4743 177.473C85.242 191.592 99.4752 202.95 114.406 213.638C123.278 219.986 133.969 224.871 144.137 229.077C156.341 234.105 169.765 237.484 182.497 240.79C185.388 241.537 186.692 241.34 188.364 243.515C190.485 246.28 192.139 255.705 190.464 258.882C187.516 264.488 180.558 261.418 175.938 260.362C162.464 257.284 150.149 249.827 137.143 245.315C127.916 242.107 131.944 246.759 126.236 252.314C121.489 256.94 113.664 256.924 108.79 252.534C107.691 251.543 105.295 248.434 105.801 246.928C106.454 244.952 109.791 246.049 110.971 244.563C117.924 235.791 99.4596 224.462 94.316 220.105C83.6035 211.05 71.6777 202.493 62.9744 191.367C52.3501 177.789 41.9228 164.168 35.0602 148.244C18.8386 110.624 28.2262 79.7358 22.577 74.6664C18.486 71.0024 11.4809 62.8525 20.1115 58.867C22.8 57.6275 27.2333 58.7166 29.9451 59.5023C33.8884 60.6458 32.7917 60.9985 35.4647 57.4304C41.018 50.0143 48.0931 44.7219 57.4989 43.8014C75.3332 42.0562 99.3378 50.9763 100.673 71.8167C101.321 81.9555 98.6274 92.2551 100.873 102.337C103.561 114.376 115.806 118.121 127.016 118.987Z",
    fill: "url(#paint0_linear_637_1031)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M100.681 71.8238C100.522 69.3993 100.038 67.1485 99.3065 65.043C98.1529 66.3447 96.828 67.5193 95.1195 68.2921C90.8496 70.2265 86.2893 70.771 81.7471 70.3924C82.696 73.0451 82.4497 76.1645 80.3704 79.6366C77.9749 83.6481 71.8539 84.0189 71.5894 89.4047C71.0968 99.3153 80.2538 91.9692 83.8108 98.1043C87.9278 105.173 84.4978 113.67 88.4333 120.923C91.5288 126.628 96.8617 130.577 102.664 133.219C112.523 137.713 130.472 141.364 140.873 136.536C145.698 134.303 143.974 130.116 142.761 125.777C140.876 119.002 137.64 119.588 131.268 119.251C129.826 119.178 128.418 119.092 127.018 118.984C115.808 118.117 103.561 114.371 100.88 102.344C98.6351 92.2622 101.329 81.9652 100.681 71.8238Z",
    fill: "#D87D05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1392 82.7507C34.6014 71.2661 37.7747 56.2446 50.5872 52.3032C56.8871 50.3636 62.9226 50.654 69.3859 51.4086C73.9254 51.935 82.735 53.5816 87.425 50.6618C78.7036 45.0945 67.2029 42.8645 57.5067 43.8135C48.1009 44.7341 41.0258 50.0265 35.4725 57.4426C32.7996 61.0106 33.8962 60.658 29.9529 59.5144C27.2411 58.7287 22.8104 57.6397 20.1193 58.8791C11.4887 62.8647 18.4938 71.0146 22.5849 74.6786C28.2341 79.748 18.8464 110.634 35.0681 148.256C41.4535 163.078 50.9397 175.903 60.7837 188.555C41.1347 156.474 28.2522 121.169 33.1392 82.7507Z",
    fill: "url(#paint1_linear_637_1031)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M188.369 243.518C186.696 241.343 185.392 241.537 182.502 240.793C178.346 239.717 174.117 238.607 169.886 237.461C169.368 258.288 128.926 236.59 119.847 232.874C110.262 228.966 86.1437 212.023 82.1797 210.133C86.2474 213.499 90.3644 216.774 94.3232 220.111C99.4669 224.467 117.931 235.796 110.978 244.569C109.798 246.054 106.459 244.955 105.808 246.933C105.303 248.437 107.696 251.549 108.798 252.54C113.672 256.927 121.496 256.945 126.243 252.319C131.952 246.762 127.923 242.11 137.15 245.32C150.159 249.832 162.471 257.293 175.945 260.368C180.565 261.423 187.523 264.493 190.471 258.887C192.143 255.706 190.489 246.282 188.369 243.518Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M99.0649 120.764C85.4047 110.675 92.4227 93.3505 88.4198 79.2107C85.5965 69.217 79.5247 57.8828 68.3093 55.6165C59.4012 53.8195 48.738 55.3235 43.8432 63.9065C36.6074 76.5891 36.1381 97.2479 38.3133 111.173C43.3688 143.547 58.2916 173.743 82.4414 196.614C99.0079 212.309 119.354 224.395 141.549 230.1C145.804 231.187 150.084 232.063 154.38 232.844C150.901 231.684 147.473 230.45 144.142 229.076C133.974 224.873 123.282 219.985 114.41 213.637C99.4823 202.946 85.2465 191.591 73.4789 177.472C69.0196 172.122 56.2746 152.892 49.9513 135.405C44.6625 120.795 41.4736 106.842 42.7881 91.0168C43.7292 79.7033 47.0606 66.8678 58.1464 62.1666C68.5582 57.748 88.5417 65.9757 80.3725 79.6385C77.977 83.65 71.8559 84.0208 71.5915 89.4065C71.0989 99.3172 80.2559 91.9711 83.8129 98.1062C87.9298 105.175 84.4999 113.672 88.4354 120.925C91.5309 126.63 96.8638 130.579 102.666 133.221C112.525 137.715 130.474 141.366 140.875 136.538C145.7 134.305 143.976 130.117 142.763 125.779C140.878 119.004 137.642 119.59 131.27 119.253C129.828 119.18 128.421 119.094 127.021 118.985C120.257 118.464 113.161 116.851 107.965 113.053C107.063 118.967 104.789 124.986 99.0649 120.764Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M21.4531 60.3995C14.7046 62.5491 26.493 75.8385 31.38 69.6566C35.6344 64.2683 26.4334 59.0926 21.7045 60.3295C21.6164 60.3502 21.536 60.3761 21.4531 60.3995Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5379 48.355C61.2671 48.202 63.0145 48.1709 64.7386 48.2565C67.3286 48.3783 69.623 48.7906 71.99 49.6852C73.8333 50.3828 76.7448 51.5808 78.4507 49.9316C80.281 48.1657 75.2877 46.9574 73.9863 46.6436C66.053 44.7273 54.8039 43.5942 47.5732 48.298C46.6891 48.871 44.5581 50.6006 45.201 51.8945C45.9658 53.4426 47.791 51.7208 48.7813 51.2385C52.1361 49.6023 55.8098 48.6921 59.5379 48.355Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9134 62.8209C23.736 58.6124 30.9692 63.6325 27.0597 66.1789C24.8352 67.6258 20.6742 65.6966 21.9134 62.8209Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.893 118.987C294.495 119.096 293.085 119.184 291.648 119.254C285.276 119.591 282.04 119.005 280.153 125.781C278.948 130.119 277.218 134.304 282.04 136.539C292.437 141.367 310.395 137.716 320.25 133.223C326.049 130.578 331.393 126.629 334.483 120.926C338.416 113.674 334.988 105.176 339.095 98.1076C342.657 91.9724 351.822 99.3211 351.322 89.4079C351.055 84.0221 344.939 83.6513 342.543 79.6399C334.377 65.9797 354.363 57.7494 364.774 62.1679C375.847 66.8717 379.176 79.7073 380.122 91.0182C381.437 106.844 378.248 120.797 372.964 135.406C366.633 152.893 353.896 172.124 349.437 177.473C337.672 191.592 323.436 202.95 308.505 213.638C299.631 219.986 288.937 224.871 278.761 229.077C266.573 234.105 253.151 237.484 240.409 240.79C237.521 241.537 236.217 241.34 234.545 243.515C232.421 246.28 230.765 255.705 232.442 258.882C235.39 264.488 242.351 261.418 246.966 260.362C260.444 257.284 272.756 249.827 285.763 245.315C294.985 242.107 290.954 246.759 296.668 252.314C301.412 256.94 309.239 256.924 314.116 252.534C315.22 251.543 317.616 248.434 317.113 246.928C316.454 244.952 313.118 246.049 311.946 244.563C304.982 235.791 323.452 224.462 328.598 220.105C339.31 211.05 351.233 202.493 359.939 191.367C370.561 177.789 380.983 164.168 387.853 148.244C404.067 110.624 394.685 79.7358 400.334 74.6664C404.423 71.0024 411.425 62.8525 402.802 58.867C400.109 57.6275 395.678 58.7166 392.969 59.5023C389.02 60.6458 390.112 60.9985 387.444 57.4304C381.888 50.0143 374.823 44.7219 365.407 43.8014C347.578 42.0562 323.576 50.9763 322.238 71.8167C321.593 81.9555 324.284 92.2551 322.041 102.337C319.355 114.376 307.098 118.121 295.893 118.987Z",
    fill: "url(#paint2_linear_637_1031)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M322.234 71.8238C322.392 69.3993 322.877 67.1485 323.603 65.043C324.749 66.3447 326.081 67.5193 327.787 68.2921C332.065 70.2265 336.612 70.771 341.167 70.3924C340.226 73.0451 340.462 76.1645 342.544 79.6366C344.94 83.6481 351.058 84.0189 351.323 89.4047C351.82 99.3153 342.658 91.9692 339.096 98.1043C334.989 105.173 338.414 113.67 334.484 120.923C331.396 126.628 326.05 130.577 320.251 133.219C310.394 137.713 292.438 141.364 282.041 136.536C277.217 134.303 278.948 130.116 280.154 125.777C282.041 119.002 285.274 119.588 291.649 119.251C293.086 119.178 294.496 119.092 295.893 118.984C307.099 118.117 319.356 114.371 322.037 102.344C324.282 92.2622 321.588 81.9652 322.234 71.8238Z",
    fill: "#D87D05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.778 82.7507C388.313 71.2661 385.14 56.2446 372.325 52.3032C366.033 50.3636 360 50.654 353.521 51.4086C348.989 51.935 340.185 53.5816 335.5 50.6618C344.206 45.0945 355.712 42.8645 365.405 43.8135C374.821 44.7341 381.886 50.0265 387.442 57.4426C390.11 61.0106 389.018 60.658 392.967 59.5144C395.676 58.7287 400.107 57.6397 402.8 58.8791C411.423 62.8647 404.421 71.0146 400.332 74.6786C394.683 79.748 404.066 110.634 387.852 148.256C381.458 163.078 371.977 175.903 362.126 188.555C381.777 156.474 394.662 121.169 389.778 82.7507Z",
    fill: "url(#paint3_linear_637_1031)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M234.546 243.518C236.218 241.343 237.519 241.537 240.41 240.793C244.566 239.717 248.794 238.607 253.028 237.461C253.549 258.288 293.985 236.59 303.067 232.874C312.652 228.966 336.776 212.023 340.735 210.133C336.672 213.499 332.55 216.774 328.596 220.111C323.45 224.467 304.98 235.796 311.944 244.569C313.116 246.054 316.455 244.955 317.111 246.933C317.614 248.437 315.221 251.549 314.114 252.54C309.24 256.927 301.41 256.945 296.666 252.319C290.952 246.762 294.983 242.11 285.762 245.32C272.755 249.832 260.443 257.293 246.964 260.368C242.352 261.423 235.391 264.493 232.44 258.887C230.766 255.706 232.422 246.282 234.546 243.518Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M323.837 120.764C337.513 110.675 330.492 93.3505 334.487 79.2107C337.316 69.217 343.383 57.8828 354.601 55.6165C363.498 53.8195 374.174 55.3235 379.064 63.9065C386.295 76.5891 386.772 97.2479 384.591 111.173C379.536 143.547 364.61 173.743 340.474 196.614C323.905 212.309 303.553 224.395 281.353 230.1C277.106 231.187 272.823 232.063 268.527 232.844C271.999 231.684 275.431 230.45 278.76 229.076C288.936 224.873 299.628 219.985 308.505 213.637C323.435 202.946 337.671 191.591 349.436 177.472C353.895 172.122 366.633 152.892 372.964 135.405C378.247 120.795 381.439 106.842 380.122 91.0168C379.175 79.7033 375.847 66.8678 364.774 62.1666C354.362 57.748 334.379 65.9757 342.543 79.6385C344.938 83.65 351.057 84.0208 351.321 89.4065C351.819 99.3172 342.657 91.9711 339.094 98.1062C334.988 105.175 338.413 113.672 334.482 120.925C331.394 126.63 326.049 130.579 320.249 133.221C310.392 137.715 292.436 141.366 282.04 136.538C277.215 134.305 278.947 130.117 280.152 125.779C282.04 119.004 285.273 119.59 291.648 119.253C293.084 119.18 294.495 119.094 295.892 118.985C302.653 118.464 309.757 116.851 314.945 113.053C315.842 118.967 318.115 124.986 323.837 120.764Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M401.461 60.3995C408.22 62.5491 396.424 75.8385 391.539 69.6566C387.285 64.2683 396.488 59.0926 401.217 60.3295C401.3 60.3502 401.383 60.3761 401.461 60.3995Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.373 48.355C361.638 48.202 359.893 48.1709 358.172 48.2565C355.577 48.3783 353.29 48.7906 350.918 49.6852C349.072 50.3828 346.166 51.5808 344.455 49.9316C342.629 48.1657 347.633 46.9574 348.922 46.6436C356.863 44.7273 368.101 43.5942 375.34 48.298C376.221 48.871 378.352 50.6006 377.72 51.8945C376.952 53.4426 375.117 51.7208 374.129 51.2385C370.774 49.6023 367.101 48.6921 363.373 48.355Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.002 62.8209C399.179 58.6124 391.943 63.6325 395.853 66.1789C398.072 67.6258 402.238 65.6966 401.002 62.8209Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.274 265.375C221.408 288.502 224.512 373.16 224.512 373.16H198.402C198.402 373.16 201.505 288.502 175.637 265.375H247.274Z",
    fill: "url(#paint4_linear_637_1031)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M247.274 265.375H175.637C180.226 269.482 183.881 275.529 186.834 282.686C188.4 280.448 190.658 278.773 194.015 278.151C202.001 276.681 213.701 274.762 220.021 281.172C223.555 284.758 226.368 290.732 225.992 295.058C225.173 304.333 224.717 315.792 224.04 325.077C222.845 341.6 220.309 356.658 220.95 373.16H224.514C224.514 373.16 221.406 288.502 247.274 265.375Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M202.229 373.162C201.705 356.556 201.21 339.948 200.126 323.381C199.346 311.536 199.042 299.242 195.332 287.866C192.665 279.717 188.19 272.637 183.85 265.377H175.637C201.505 288.504 198.402 373.162 198.402 373.162H202.229Z",
    fill: "#D87D05"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M247.274 265.376L224.039 261.859C219.717 272.302 219.194 310.935 217.91 321.554C217.387 335.94 218.782 358.78 217.91 373.161H224.511C224.511 373.161 221.405 288.503 247.274 265.376Z",
    fill: "#D87D05"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M202.298 311.382C202.747 321.329 203.62 331.247 204.108 341.14C204.432 347.609 202.887 355.819 204.891 361.889C206.612 367.088 209.08 364.576 209.824 360.388C210.934 354.087 210.672 347.298 210.89 340.893C211.393 325.781 212.179 310.42 211.603 295.268C211.442 291.042 211.269 285.677 207.774 282.684C205.482 280.724 200.434 279.072 198.534 282.093C196.646 285.083 199.426 293.663 200.056 296.902C200.994 301.699 202.078 306.476 202.298 311.382Z",
    fill: "#FFD629"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.278 239.542C247.278 244.617 231.243 248.732 211.462 248.732C191.678 248.732 175.641 244.619 175.641 239.542C175.641 234.465 191.678 230.342 211.462 230.342C231.243 230.342 247.278 234.465 247.278 239.542Z",
    fill: "url(#paint5_linear_637_1031)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M247.223 239.273C229.63 251.751 179.367 246.256 176.044 238.246C175.8 238.674 175.637 239.097 175.637 239.543C175.637 244.617 191.674 248.732 211.458 248.732C231.242 248.732 247.274 244.62 247.274 239.543C247.274 239.454 247.236 239.366 247.223 239.273Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.454 248.733C191.67 248.733 175.633 244.62 175.633 239.543V264.379C175.633 269.451 191.67 273.574 211.454 273.574C231.238 273.574 247.271 269.451 247.271 264.379V239.543C247.273 244.62 231.238 248.733 211.454 248.733Z",
    fill: "url(#paint6_linear_637_1031)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M231.692 247.125C231.391 253.307 231.098 259.071 226.263 263.925C219.074 271.142 205.994 270.04 196.959 269.148C181.925 267.678 177.717 255.306 177.668 242.572C176.372 241.623 175.633 240.606 175.633 239.543V264.379C175.633 269.451 191.67 273.574 211.454 273.574C231.238 273.574 247.271 269.451 247.271 264.379V239.543C247.273 242.688 241.095 245.468 231.692 247.125Z",
    fill: "#E58800"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M177.149 242.141C176.198 241.317 175.633 240.448 175.633 239.543V264.379C175.633 266.539 178.586 268.51 183.455 270.084C177.881 262.115 175.957 252.467 177.149 242.141Z",
    fill: "#D87C03"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M246.034 241.846C244.66 243.197 242.177 244.439 238.754 245.476C240.893 256.942 234.941 268.308 224.047 272.973C224.042 272.973 224.039 272.973 224.039 272.978C235.332 271.891 243.826 269.374 246.374 266.29C246.597 258.151 246.229 249.998 246.034 241.846Z",
    fill: "#D87C03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.109 62.1737C157.283 62.1737 112.999 51.5967 107.368 38.0117C107.072 231.845 203.876 242.282 210.899 242.78V242.808C210.899 242.808 210.98 242.808 211.099 242.795C211.236 242.808 211.314 242.808 211.314 242.808V242.78C218.345 242.284 315.149 231.845 314.846 38.0117C309.23 51.5967 264.928 62.1737 211.109 62.1737Z",
    fill: "url(#paint7_linear_637_1031)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M211.109 62.1737C157.283 62.1737 112.999 51.5967 107.368 38.0117C107.334 59.1139 108.459 78.0302 110.487 95.0017C111.625 89.3618 113.642 83.9139 117.139 78.79C126.597 64.9094 146.985 64.3286 161.892 65.5032C188.313 67.5725 242.765 62.9335 254.875 94.076C270.028 133.06 257.804 188.683 233.592 219.551C227.01 227.968 211.317 242.78 192.474 238.128C202.134 241.937 209.181 242.658 210.899 242.782V242.811C210.899 242.811 210.98 242.811 211.099 242.798C211.237 242.811 211.314 242.811 211.314 242.811V242.782C218.345 242.287 315.149 231.847 314.846 38.0143C309.23 51.5967 264.929 62.1737 211.109 62.1737Z",
    fill: "#E58800"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M255.676 59.5807C256.274 81.6216 256.088 108.081 254.063 125.519C250.566 155.417 239.161 219.471 196.446 217.139C160.604 215.202 142.557 172.122 137.112 142.592C131.689 113.195 130.996 83.0348 133.82 53.277C119.392 49.1515 109.789 43.8616 107.368 38.0117C107.072 231.845 203.876 242.282 210.899 242.78V242.808C210.899 242.808 210.98 242.808 211.099 242.795C211.236 242.808 211.314 242.808 211.314 242.808V242.78C218.345 242.284 315.149 231.845 314.846 38.0117C310.892 47.5697 287.779 55.6341 255.676 59.5807Z",
    fill: "#FC9610"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M289.804 52.8595C291.699 179.354 261.794 201.957 240.968 219.551C202.663 251.912 164.824 219.691 146.847 193.193C122.091 156.69 114.868 91.9316 118.384 47.5204C112.61 44.6188 108.776 41.4086 107.368 38.0117C107.072 231.845 203.876 242.282 210.899 242.78V242.808C210.899 242.808 210.98 242.808 211.099 242.795C211.236 242.808 211.314 242.808 211.314 242.808V242.78C218.345 242.284 315.149 231.845 314.846 38.0117C312.507 43.6646 303.441 48.7936 289.804 52.8595Z",
    fill: "#E58800"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M191.639 105.592C256.923 107.378 277.783 100.8 297.826 103.572C302.705 104.238 306.661 105.854 309.907 108.229C313.073 88.0161 314.89 64.7694 314.846 38.0117C309.23 51.5993 264.929 62.1737 211.11 62.1737C157.283 62.1737 112.999 51.5967 107.368 38.0117C107.327 62.2178 108.807 83.5534 111.431 102.366C115.527 91.1277 148.32 104.399 191.639 105.592Z",
    fill: "#C96C06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.463 35.0896C315.463 50.0489 268.75 62.174 211.113 62.174C153.472 62.174 106.754 50.0489 106.754 35.0896C106.754 20.1251 153.472 8 211.113 8C268.75 8 315.463 20.1251 315.463 35.0896Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.539 50.3449C140.159 48.5505 131.248 46.2038 124.119 43.1621C122.812 44.9046 121.539 46.6524 120.43 48.4908C127.354 51.6414 136.672 54.39 147.693 56.5889C148.271 54.4937 148.896 52.4193 149.539 50.3449Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.653 54.3142C226.707 54.9858 214.706 55.2373 202.658 55.3021C192.648 55.3592 176.382 54.4827 160.135 52.123C159.476 54.2182 158.815 56.316 158.219 58.4371C173.727 60.8072 191.8 62.1711 211.112 62.1711C220.956 62.1711 230.492 61.8133 239.514 61.1469C239.135 58.9039 238.881 56.6142 238.653 54.3142Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.109 8C153.468 8 106.75 20.1251 106.75 35.0896C106.75 36.5832 107.237 38.0482 108.127 39.4718C112.931 8 226.135 13.3987 258.988 28.3658C269.864 33.3185 284.686 39.4277 289.083 53.0776C305.486 48.2934 315.459 41.9923 315.459 35.0896C315.462 20.1251 268.749 8 211.109 8Z",
    fill: "#FFE133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.55 33.9181C301.55 43.7121 261.192 51.6468 211.401 51.6468C161.601 51.6468 121.234 43.7095 121.234 33.9181C121.234 24.1268 161.598 16.1895 211.401 16.1895C261.192 16.1869 301.55 24.1268 301.55 33.9181Z",
    fill: "url(#paint8_linear_637_1031)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M191.636 16.6211C166.185 17.7413 144.791 20.9748 132.5 25.3363C132.611 28.0487 132.72 30.7532 132.936 33.4604C133.459 36.6861 133.944 39.917 134.416 43.1532C146.878 47.1646 167.238 50.1155 191.242 51.1942C190.358 39.6162 190.397 27.9864 191.636 16.6211Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M171.346 27.9865C170.822 24.7348 170.361 21.465 170.06 18.1641C159.298 19.2635 149.828 20.7753 142.156 22.593C142.325 25.0564 142.473 27.5302 142.703 29.991C143.481 34.9696 144.298 39.9457 145.029 44.9217C145.203 45.2796 145.353 45.6504 145.529 46.003C153.322 47.6444 162.731 48.9669 173.184 49.9367C172.261 42.6632 171.686 35.3378 171.346 27.9865Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.583 20.0605C260.819 36.5731 240.916 45.9988 223.969 51.4727C267.806 50.2721 301.549 42.869 301.549 33.9178C301.549 28.3013 288.277 23.3044 267.583 20.0605Z",
    fill: "#C96C06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.624 103.703C260.668 103.703 301.778 94.9226 312.957 83.088C314.194 69.2748 314.868 54.3129 314.842 38.0078C309.227 51.5954 264.925 62.1698 211.106 62.1698C157.279 62.1698 112.995 51.5928 107.364 38.0078C107.336 53.7476 107.968 68.2635 109.127 81.6721C118.25 94.2095 160.649 103.703 211.624 103.703Z",
    fill: "url(#paint9_linear_637_1031)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.66
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.908 43.7922C310.388 60.9893 308.125 77.4007 293 87.7444C279.067 97.279 221.121 102.74 193.831 101.236C152.711 98.9645 134.156 91.6314 124.457 86.3856C107.6 77.284 108.785 59.3868 110.846 42.5891C109.205 41.1136 108.015 39.5811 107.364 38.0045C107.336 53.7443 107.968 68.2602 109.127 81.6689C118.25 94.2063 160.652 103.697 211.624 103.697C260.668 103.697 301.778 94.9168 312.957 83.0821C314.194 69.2689 314.868 54.307 314.842 38.002C314.023 40.009 312.33 41.9434 309.908 43.7922Z",
    fill: "#FFFF71"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M118.867 70.7217C121.439 72.1349 127.812 75.9182 130.736 73.6181C133.666 71.3025 131.12 64.278 129.756 61.5631C127.399 56.8333 121.963 52.8271 117.527 50.1744C112.049 46.9072 103.641 43.9355 105.057 53.9239C105.98 60.4014 113.296 67.6671 118.867 70.7217Z",
    fill: "url(#paint10_linear_637_1031)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M114.208 62.174C109.738 58.427 106.332 53.215 106.632 47.6892C105.271 48.5579 104.561 50.4404 105.056 53.9203C105.979 60.3977 113.295 67.6661 118.867 70.7207C121.335 72.0716 127.272 75.5541 130.329 73.8142C125.913 72.4243 120.687 67.5934 114.208 62.174Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M115.218 67.4543C109.577 62.8568 105.652 58.0078 105.787 51.2477C105.794 50.5502 105.73 48.888 105.914 48.3435C105.045 49.3807 104.656 51.1336 105.056 53.9263C105.979 60.4038 113.295 67.6721 118.866 70.7267C121.163 71.9895 126.468 75.0493 129.649 74.0406C124.456 73.5168 119.094 70.6074 115.218 67.4543Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M131.998 71.1808C130.619 68.86 128.454 66.7078 126.93 64.8667C123.074 60.1759 117.394 54.4115 111.195 53.2732C115.058 56.4082 118.812 60.4896 122.514 64.0188C124.537 65.9428 126.383 68.1858 128.164 70.3277C128.496 70.7296 129.481 72.2932 130.515 73.7246C130.58 73.6805 130.66 73.6701 130.735 73.6182C131.451 73.0478 131.835 72.1895 131.998 71.1808Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.541 50.0164C113.004 50.2057 115.464 51.2585 117.528 52.4876C121.295 54.7125 123.724 57.8552 126.584 60.8813C125.938 56.8828 122.008 53.9605 118.796 52.039C117.02 50.9733 115.226 49.8816 113.279 49.1374C112.13 48.7044 110.427 48.3439 109.201 48.4995C108.705 48.5592 107.793 48.5099 107.668 49.1789C107.461 50.3484 109.976 49.9698 110.541 50.0164Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.542 82.5462C148.959 80.8659 155.163 76.8233 154.398 73.1904C153.623 69.5368 146.195 68.7071 143.154 68.7226C137.873 68.7408 131.871 71.8447 127.536 74.6374C122.172 78.1043 115.781 84.3354 125.364 87.4885C131.581 89.5266 141.334 86.1868 146.542 82.5462Z",
    fill: "url(#paint11_linear_637_1031)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M136.807 82.9339C131.474 85.2858 125.294 86.0248 120.477 83.3176C120.65 84.9098 122.027 86.3878 125.358 87.4899C131.575 89.528 141.329 86.1881 146.537 82.5475C148.847 80.9372 154.597 77.1514 154.39 73.6404C151.193 76.9854 144.551 79.5292 136.807 82.9339Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M142.001 84.363C135.38 87.3865 129.287 88.7557 123.288 85.644C122.661 85.3225 121.152 84.6405 120.742 84.2412C121.289 85.4806 122.684 86.6008 125.362 87.4903C131.579 89.5284 141.332 86.1885 146.541 82.5479C148.695 81.0439 153.784 77.6445 154.29 74.3435C151.524 78.7647 146.538 82.2912 142.001 84.363Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M152.772 70.9763C150.074 71.1812 147.191 72.1717 144.87 72.7162C138.954 74.0983 131.272 76.6343 127.508 81.6934C132.027 79.6215 137.349 78.0657 142.151 76.305C144.772 75.3456 147.595 74.6818 150.307 74.0335C150.818 73.9168 152.653 73.7224 154.388 73.4345C154.382 73.3515 154.413 73.2764 154.398 73.1908C154.201 72.2936 153.607 71.5701 152.772 70.9763Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.293 80.8305C125.561 78.712 127.585 76.9694 129.613 75.6574C133.266 73.2743 137.165 72.4783 141.142 71.2595C137.269 70.0616 132.916 72.2994 129.774 74.3219C128.024 75.4473 126.253 76.5727 124.731 77.9833C123.824 78.8235 122.753 80.1952 122.346 81.3569C122.182 81.8288 121.731 82.6223 122.278 83.032C123.219 83.7477 124.008 81.3154 124.293 80.8305Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.889 85.0112C167.595 86.1651 174.31 89.2768 176.986 86.6967C179.672 84.101 176.431 77.3669 174.803 74.7972C171.98 70.3345 166.159 66.8962 161.49 64.7076C155.711 62.0057 147.029 59.8975 149.458 69.6889C151.024 76.0444 159.04 82.5348 164.889 85.0112Z",
    fill: "url(#paint12_linear_637_1031)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M159.389 76.9764C154.565 73.6988 150.65 68.8602 150.388 63.3318C149.123 64.3301 148.609 66.2801 149.452 69.6873C151.021 76.0403 159.037 82.5333 164.888 85.0097C167.478 86.1091 173.734 88.9744 176.607 86.9337C172.07 85.9976 166.387 81.7217 159.389 76.9764Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M160.933 82.1273C154.859 78.1237 150.462 73.6973 149.907 66.9554C149.847 66.2605 149.624 64.6139 149.741 64.0564C148.989 65.174 148.779 66.9554 149.456 69.6911C151.024 76.0441 159.041 82.537 164.892 85.0134C167.303 86.0377 172.893 88.5451 175.957 87.2227C170.738 87.2227 165.105 84.8734 160.933 82.1273Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M177.993 84.1491C176.386 81.9762 174.024 80.0469 172.328 78.377C168.012 74.0985 161.774 68.9331 155.5 68.4275C159.651 71.158 163.799 74.8401 167.841 77.9777C170.044 79.6839 172.108 81.7298 174.086 83.6798C174.47 84.0454 175.608 85.5027 176.782 86.82C176.839 86.7707 176.925 86.7552 176.985 86.6955C177.643 86.055 177.939 85.163 177.993 84.1491Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.52 65.2527C156.985 65.1983 159.536 65.9892 161.722 67.0082C165.686 68.8389 168.426 71.7172 171.579 74.4425C170.537 70.5296 166.321 68.0195 162.935 66.4326C161.063 65.5535 159.163 64.6382 157.159 64.1014C155.969 63.7825 154.234 63.601 153.045 63.8784C152.555 63.9847 151.639 64.0288 151.577 64.7108C151.479 65.8984 153.947 65.2631 154.52 65.2527Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.623 93.984C195.843 92.0677 201.616 87.4235 200.494 83.884C199.358 80.329 191.879 80.2486 188.861 80.5701C183.606 81.125 177.938 84.8123 173.915 88.0355C168.921 92.0262 163.197 98.8667 173.051 101.037C179.432 102.445 188.806 98.138 193.623 93.984Z",
    fill: "url(#paint13_linear_637_1031)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M183.981 95.347C178.912 98.2279 172.83 99.5919 167.77 97.3722C168.109 98.9462 169.623 100.276 173.053 101.036C179.431 102.444 188.806 98.1372 193.623 93.9831C195.746 92.142 201.092 87.7987 200.527 84.3318C197.688 87.9854 191.333 91.18 183.981 95.347Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M189.282 96.2499C183.002 99.9268 177.081 101.903 170.794 99.416C170.143 99.1619 168.564 98.6329 168.121 98.2776C168.787 99.4523 170.294 100.43 173.052 101.039C179.43 102.447 188.805 98.1402 193.622 93.9862C195.613 92.2696 200.334 88.3774 200.502 85.0427C198.197 89.7258 193.601 93.7372 189.282 96.2499Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M198.646 81.8376C195.989 82.32 193.212 83.5906 190.957 84.3685C185.214 86.3418 177.831 89.6401 174.598 95.0492C178.883 92.5366 184.022 90.4492 188.616 88.214C191.128 86.9926 193.871 86.0539 196.5 85.1308C196.992 84.9597 198.804 84.5811 200.508 84.1169C200.495 84.0417 200.521 83.9614 200.495 83.8784C200.207 83.0097 199.541 82.3407 198.646 81.8376Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.316 94.5291C172.345 92.2913 174.199 90.3595 176.081 88.8477C179.48 86.1069 183.273 84.9297 187.1 83.3168C183.133 82.5103 179.019 85.176 176.097 87.5046C174.474 88.7985 172.822 90.1028 171.448 91.6586C170.637 92.5791 169.706 94.052 169.429 95.2526C169.304 95.7401 168.933 96.575 169.525 96.9303C170.536 97.5422 171.077 95.0425 171.316 94.5291Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.386 87.1543C209.253 87.8492 216.386 89.8407 218.605 86.8613C220.837 83.8715 216.554 77.7415 214.534 75.4778C211.019 71.5234 204.724 69.073 199.762 67.6675C193.618 65.9354 184.715 65.2534 188.692 74.5287C191.264 80.5394 200.216 85.6529 206.386 87.1543Z",
    fill: "url(#paint14_linear_637_1031)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M199.67 80.1214C194.384 77.6606 189.741 73.5169 188.582 68.1052C187.501 69.2954 187.306 71.2999 188.688 74.5308C191.262 80.5441 200.217 85.655 206.385 87.1563C209.13 87.8202 215.77 89.6379 218.264 87.1563C213.639 86.9722 207.344 83.6661 199.67 80.1214Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M202.022 84.9414C195.38 81.975 190.325 78.311 188.694 71.7506C188.523 71.0738 188.033 69.4895 188.072 68.9138C187.494 70.1403 187.577 71.9347 188.689 74.5252C191.263 80.5384 200.218 85.6493 206.386 87.1507C208.947 87.7756 214.861 89.347 217.668 87.5397C212.512 88.3876 206.58 86.9822 202.022 84.9414Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M219.191 84.1825C217.252 82.3026 214.603 80.7805 212.65 79.401C207.714 75.8822 200.73 71.7878 194.445 72.3038C198.99 74.3264 203.675 77.2928 208.17 79.7329C210.62 81.0657 212.987 82.746 215.266 84.3589C215.694 84.6519 217.05 85.9095 218.414 87.0245C218.471 86.9597 218.554 86.9389 218.603 86.8663C219.15 86.1273 219.3 85.1938 219.191 84.1825Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.969 69.331C195.393 68.8772 198.045 69.2428 200.355 69.8963C204.568 71.0632 207.739 73.4695 211.283 75.6451C209.621 71.9474 205.069 70.1504 201.465 69.1339C199.466 68.5712 197.457 67.9748 195.388 67.7674C194.159 67.6429 192.419 67.7441 191.286 68.2108C190.815 68.3975 189.925 68.5842 189.975 69.2688C190.065 70.4564 192.412 69.4347 192.969 69.331Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.205 91.3667C238.085 89.1134 243.034 83.5979 241.349 80.2892C239.658 76.9675 232.259 78.0981 229.335 78.8993C224.235 80.2944 219.244 84.8504 215.786 88.6777C211.508 93.4282 206.961 101.101 217.041 101.648C223.569 102.006 232.116 96.2416 236.205 91.3667Z",
    fill: "url(#paint15_linear_637_1031)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M226.904 94.2776C222.364 97.9364 216.591 100.26 211.234 98.8984C211.82 100.392 213.531 101.455 217.042 101.652C223.57 102.007 232.118 96.2431 236.206 91.3708C238.008 89.2108 242.571 84.0662 241.464 80.7263C239.244 84.7896 233.489 88.9748 226.904 94.2776Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M232.282 94.3078C226.677 98.9468 221.157 101.859 214.556 100.412C213.869 100.267 212.233 100.002 211.73 99.7247C212.578 100.772 214.214 101.496 217.043 101.651C223.571 102.007 232.118 96.2422 236.207 91.3699C237.882 89.3577 241.916 84.755 241.553 81.4333C240.031 86.4276 236.132 91.1236 232.282 94.3078Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M239.198 78.5759C236.649 79.4809 234.124 81.1845 232.016 82.3151C226.67 85.1908 219.912 89.6379 217.594 95.5008C221.42 92.3217 226.157 89.4382 230.334 86.4847C232.612 84.8744 235.169 83.5053 237.616 82.1777C238.072 81.9236 239.802 81.2571 241.404 80.5285C241.37 80.4481 241.388 80.3677 241.347 80.2899C240.922 79.4783 240.159 78.9312 239.198 78.5759Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.273 95.5064C214.937 93.1311 216.44 90.9245 218.053 89.1353C220.959 85.8758 224.519 84.0944 228.045 81.8877C223.998 81.7347 220.368 85.0357 217.861 87.7998C216.466 89.3401 215.048 90.8907 213.949 92.6514C213.293 93.6912 212.616 95.2938 212.525 96.5255C212.494 97.0207 212.258 97.9049 212.894 98.1617C213.993 98.6025 214.117 96.0561 214.273 95.5064Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.261 84.5474C251.185 84.9079 258.502 86.0592 260.358 82.8464C262.225 79.6129 257.262 74.0248 254.991 72.0049C251.043 68.4913 244.507 66.7799 239.418 65.9605C233.11 64.9544 224.194 65.3096 229.208 74.0611C232.467 79.7347 241.956 83.7773 248.261 84.5474Z",
    fill: "url(#paint16_linear_637_1031)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M240.771 78.3354C235.231 76.5125 230.136 72.9289 228.365 67.6909C227.427 68.9978 227.466 71.0152 229.208 74.062C232.467 79.7382 241.958 83.7782 248.261 84.5483C251.056 84.8906 257.861 85.9278 260.052 83.1714C255.44 83.5293 248.8 80.9777 240.771 78.3354Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M243.659 82.862C236.724 80.6865 231.277 77.6344 228.892 71.3048C228.651 70.6488 227.979 69.1318 227.948 68.564C227.518 69.8475 227.813 71.6212 229.208 74.0612C232.467 79.7374 241.958 83.7774 248.261 84.5475C250.872 84.869 256.92 85.7481 259.513 83.6322C254.491 85.0687 248.437 84.3608 243.659 82.862Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M260.626 80.1165C258.49 78.4648 255.677 77.2694 253.587 76.1181C248.259 73.1931 240.858 69.9414 234.672 71.1835C239.427 72.6667 244.42 75.0679 249.164 76.9764C251.767 78.0084 254.308 79.4112 256.75 80.7415C257.209 80.9878 258.708 82.0795 260.196 83.0234C260.235 82.9533 260.315 82.9222 260.356 82.847C260.82 82.0458 260.857 81.1045 260.626 80.1165Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.868 68.405C235.22 67.6712 237.895 67.7308 240.273 68.1094C244.595 68.7888 248.017 70.801 251.789 72.5591C249.717 69.0766 244.976 67.8242 241.281 67.2278C239.233 66.8933 237.164 66.5406 235.077 66.5717C233.848 66.5873 232.14 66.8881 231.061 67.4871C230.623 67.7282 229.752 68.0161 229.89 68.6851C230.115 69.8571 232.332 68.571 232.868 68.405Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.353 85.2779C279.976 82.8196 284.241 76.7701 282.185 73.6817C280.113 70.5701 272.901 72.5538 270.085 73.6947C265.191 75.6706 260.77 80.7737 257.771 84.9771C254.071 90.1839 250.449 98.3364 260.521 97.7115C267.044 97.3044 274.871 90.591 278.353 85.2779Z",
    fill: "url(#paint17_linear_637_1031)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M269.46 89.2434C265.377 93.3975 259.914 96.3769 254.426 95.6482C255.183 97.0692 257.011 97.9301 260.521 97.7149C267.046 97.3078 274.871 90.5944 278.355 85.2812C279.898 82.9319 283.849 77.2869 282.343 74.0974C280.618 78.3941 275.379 83.212 269.46 89.2434Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M274.799 88.6538C269.778 93.91 264.624 97.4469 257.906 96.7701C257.212 96.7104 255.545 96.6404 255.016 96.4148C255.985 97.3613 257.699 97.8877 260.522 97.714C267.048 97.3068 274.872 90.5934 278.356 85.2803C279.803 83.0892 283.272 78.0431 282.515 74.7888C281.584 79.9282 278.255 85.0469 274.799 88.6538Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M279.858 72.2224C277.426 73.4126 275.114 75.3989 273.156 76.7654C268.181 80.2401 261.982 85.4392 260.359 91.538C263.787 87.9337 268.163 84.5161 271.964 81.1036C274.04 79.2418 276.42 77.5822 278.691 75.9797C279.127 75.6763 280.763 74.8181 282.269 73.9027C282.235 73.8301 282.235 73.7497 282.186 73.6797C281.675 72.9173 280.843 72.4636 279.858 72.2224Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.058 91.9323C257.436 89.4896 258.686 87.1248 260.078 85.1567C262.593 81.5834 265.917 79.4079 269.162 76.8044C265.123 77.1182 261.901 80.8185 259.728 83.8601C258.525 85.5482 257.289 87.2518 256.407 89.1344C255.873 90.239 255.386 91.909 255.437 93.1432C255.458 93.6411 255.334 94.5513 255.995 94.7276C257.138 95.0362 256.97 92.4898 257.058 91.9323Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.053 74.4739C288.983 74.212 296.377 73.792 297.512 70.2602C298.666 66.7052 292.636 62.2892 289.986 60.7982C285.395 58.1896 278.641 57.8966 273.484 58.1662C267.115 58.5111 258.473 60.7412 265.225 68.2377C269.596 73.1022 279.733 75.0522 286.053 74.4739Z",
    fill: "url(#paint18_linear_637_1031)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M277.424 69.9811C271.627 69.3665 265.885 66.9368 263.046 62.189C262.416 63.667 262.872 65.6248 265.226 68.2385C269.597 73.1031 279.734 75.0505 286.055 74.4722C288.86 74.2233 295.728 73.7954 297.296 70.6423C292.848 71.9648 285.824 70.8705 277.424 69.9811Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M281.21 73.7936C273.961 73.1298 267.99 71.2913 264.327 65.6126C263.948 65.0239 262.976 63.6756 262.826 63.1284C262.673 64.4742 263.342 66.1415 265.224 68.2393C269.595 73.1039 279.732 75.0513 286.053 74.473C288.666 74.237 294.777 73.8196 296.856 71.211C292.257 73.6743 286.182 74.2552 281.21 73.7936Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M297.21 67.5351C294.765 66.376 291.768 65.7951 289.487 65.1132C283.669 63.3732 275.736 61.7552 269.957 64.2756C274.914 64.719 280.304 66.0207 285.347 66.8738C288.097 67.3432 290.884 68.1755 293.552 68.9638C294.042 69.1116 295.745 69.8532 297.399 70.4652C297.43 70.39 297.495 70.3381 297.516 70.2604C297.793 69.3813 297.643 68.4556 297.21 67.5351Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.603 61.932C269.755 60.7159 272.381 60.2154 274.779 60.0858C279.14 59.8394 282.915 61.0841 286.975 62.0072C284.211 59.0382 279.311 58.81 275.583 59.007C273.506 59.116 271.409 59.2067 269.377 59.6786C268.184 59.9587 266.569 60.6147 265.646 61.4186C265.267 61.7453 264.484 62.2172 264.749 62.8422C265.228 63.9312 267.113 62.2172 267.603 61.932Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.616 68.8413C316.676 66.103 319.585 59.2859 316.92 56.7032C314.242 54.0998 307.612 57.5512 305.095 59.2626C300.727 62.2238 297.468 68.1438 295.433 72.8787C292.913 78.7571 291.09 87.4879 300.807 84.7574C307.097 82.989 313.334 74.7742 315.616 68.8413Z",
    fill: "url(#paint19_linear_637_1031)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M307.752 74.5932C304.643 79.5226 299.93 83.5833 294.418 84.0242C295.452 85.2533 297.412 85.7045 300.809 84.7606C307.096 82.9895 313.333 74.7748 315.615 68.8419C316.636 66.2203 319.296 59.8725 317.157 57.072C316.38 61.6358 312.283 67.4494 307.752 74.5932Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M312.862 72.8917C309.059 79.0891 304.763 83.6295 298.043 84.3867C297.353 84.4723 295.72 84.7523 295.145 84.6486C296.288 85.3746 298.079 85.5224 300.809 84.7601C307.096 82.989 313.334 74.7743 315.615 68.8414C316.575 66.3909 318.895 60.7355 317.479 57.7146C317.648 62.9318 315.475 68.6365 312.862 72.8917Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M314.339 55.7673C312.208 57.445 310.365 59.8721 308.744 61.6224C304.612 66.0695 299.644 72.4588 299.344 78.7599C301.934 74.5151 305.488 70.2547 308.493 66.1188C310.131 63.8576 312.11 61.7339 313.994 59.6828C314.35 59.3017 315.77 58.1115 317.046 56.9057C316.994 56.8409 316.976 56.7579 316.919 56.706C316.26 56.0629 315.355 55.7907 314.339 55.7673Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.205 79.8323C296.06 77.3715 296.785 74.7914 297.721 72.577C299.435 68.5604 302.225 65.7287 304.838 62.4978C300.962 63.6621 298.598 67.9536 297.115 71.3842C296.288 73.2901 295.445 75.2167 294.973 77.2367C294.685 78.4321 294.561 80.172 294.877 81.3648C294.994 81.8471 295.074 82.7599 295.751 82.7988C296.933 82.8506 296.231 80.4002 296.205 79.8323Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.056 213.254C215.56 210.508 211.648 207.334 206.852 204.126C200.186 199.684 192.707 196.321 187.052 190.479C181.395 184.647 175.705 178.559 170.517 172.227C158.347 157.381 149.154 139.539 141.047 122.251C140.319 122.157 139.917 121.75 140.575 124.976C143.147 137.539 149.971 151.736 156.273 162.809C170.823 188.361 193.49 204.261 217.118 219.171C217.751 217.032 218.759 215.056 220.056 213.254Z",
    fill: "#AD611C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.056 213.254C215.56 210.508 211.648 207.334 206.852 204.126C200.186 199.684 192.707 196.321 187.052 190.479C181.395 184.647 175.705 178.559 170.517 172.227C158.347 157.381 149.154 139.539 141.047 122.251C140.319 122.157 139.917 121.75 140.575 124.976C140.736 125.801 140.98 126.649 141.182 127.484C141.275 127.642 141.39 127.777 141.465 127.958C151.959 152.366 160.061 166.69 175.746 185.213C184.646 195.709 192.108 199.389 196.92 202.983C198.353 204.051 199.753 205.145 201.156 206.253C206.761 209.86 212.491 212.974 218.249 216.225C218.759 215.183 219.382 214.195 220.056 213.254Z",
    fill: "#CE7125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.207 212.401C216.599 213.026 217.901 213.763 219.176 214.569C219.451 214.115 219.752 213.68 220.058 213.255C215.562 210.508 211.65 207.335 206.854 204.127C200.188 199.685 192.709 196.322 187.054 190.48C181.397 184.648 175.707 178.56 170.519 172.227C158.349 157.382 149.156 139.539 141.049 122.251C140.373 122.174 139.981 121.847 140.466 124.401C140.857 124.795 141.207 125.27 141.472 125.892C152.319 150.928 166.646 178.435 188.646 195.578C188.934 195.808 189.167 196.05 189.393 196.304C193.341 198.92 196.862 202.097 201.09 204.353C205.399 206.655 209.799 208.789 213.986 211.336C214.504 211.647 214.893 212.007 215.207 212.401Z",
    fill: "#874315"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.824 116.125C143.146 118.163 144.1 123.287 141.878 124.669C139.635 126.051 135.612 122.667 134.144 121.106C131.593 118.407 130.248 113.848 129.584 110.267C128.739 105.851 128.809 99.5709 135.073 102.929C139.13 105.099 142.163 111.699 142.824 116.125Z",
    fill: "url(#paint20_linear_637_1031)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M138.304 110.982C136.92 107.113 134.288 103.597 130.57 102.461C131.47 101.779 132.888 101.758 135.074 102.93C139.128 105.101 142.162 111.703 142.825 116.126C143.131 118.087 143.989 122.85 142.102 124.445C142.25 121.193 140.324 116.567 138.304 110.982Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M141.549 112.916C139.879 108.082 137.616 104.307 133.12 102.756C132.659 102.595 131.58 102.16 131.176 102.141C132.068 101.817 133.317 101.986 135.072 102.925C139.127 105.095 142.16 111.697 142.824 116.121C143.115 117.951 143.851 122.191 142.409 124.05C143.317 120.49 142.702 116.245 141.549 112.916Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M139.963 124.917C138.757 123.442 137.86 121.484 137.005 120.045C134.85 116.355 132.408 111.197 133.152 106.828C134.293 110.145 136.082 113.612 137.521 116.912C138.296 118.712 139.333 120.481 140.318 122.163C140.502 122.49 141.303 123.522 141.993 124.554C141.943 124.58 141.918 124.637 141.873 124.671C141.326 125.005 140.663 125.057 139.963 124.917Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.167 105.605C130.695 107.281 130.788 109.163 131.107 110.828C131.67 113.854 133.153 116.224 134.467 118.84C131.971 117.45 130.998 114.139 130.508 111.554C130.226 110.123 129.948 108.676 129.923 107.203C129.91 106.339 130.081 105.133 130.483 104.358C130.641 104.047 130.827 103.422 131.302 103.513C132.121 103.653 131.268 105.227 131.167 105.605Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.239 131.636C136.263 132.041 141.335 133.228 142.815 131.068C144.3 128.895 141.096 124.715 139.613 123.173C137.023 120.507 132.525 118.961 128.996 118.132C124.623 117.087 118.349 116.866 121.416 123.274C123.402 127.43 129.852 130.76 134.239 131.636Z",
    fill: "url(#paint21_linear_637_1031)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M129.306 126.881C125.514 125.309 122.122 122.529 121.153 118.754C120.43 119.628 120.344 121.044 121.415 123.276C123.401 127.43 129.851 130.76 134.238 131.639C136.185 132.023 140.9 133.104 142.578 131.284C139.332 131.284 134.803 129.152 129.306 126.881Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M131.097 130.209C126.332 128.318 122.677 125.891 121.329 121.322C121.191 120.853 120.805 119.753 120.805 119.352C120.439 120.223 120.556 121.488 121.412 123.275C123.398 127.429 129.848 130.758 134.234 131.637C136.052 132 140.252 132.929 142.168 131.575C138.574 132.319 134.364 131.51 131.097 130.209Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M143.155 129.163C141.726 127.9 139.823 126.91 138.418 125.992C134.835 123.666 129.798 120.998 125.398 121.542C128.652 122.828 132.041 124.776 135.274 126.355C137.034 127.229 138.753 128.333 140.389 129.404C140.7 129.601 141.698 130.442 142.691 131.181C142.722 131.142 142.771 131.113 142.815 131.067C143.176 130.53 143.256 129.871 143.155 129.163Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.268 119.493C125.955 119.102 127.835 119.283 129.481 119.675C132.489 120.377 134.775 121.964 137.339 123.393C136.061 120.849 132.8 119.719 130.238 119.107C128.807 118.762 127.381 118.407 125.917 118.324C125.056 118.272 123.84 118.396 123.047 118.752C122.73 118.902 122.103 119.06 122.16 119.54C122.264 120.37 123.876 119.584 124.268 119.493Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.715 143.491C140.005 143.602 145.771 144.071 147.025 141.465C148.298 138.841 144.111 134.778 142.232 133.331C138.949 130.824 133.759 129.867 129.754 129.53C124.779 129.099 117.856 129.9 122.266 136.43C125.131 140.651 132.758 143.255 137.715 143.491Z",
    fill: "url(#paint22_linear_637_1031)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M131.527 139.08C127.099 137.983 122.924 135.486 121.244 131.508C120.589 132.579 120.734 134.153 122.269 136.424C125.133 140.648 132.761 143.252 137.718 143.488C139.916 143.594 145.267 144.004 146.807 141.737C143.245 142.274 137.928 140.677 131.527 139.08Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M134.034 142.443C128.501 141.151 124.088 139.082 121.861 134.295C121.638 133.8 121.021 132.659 120.967 132.221C120.713 133.242 121.04 134.604 122.266 136.429C125.131 140.653 132.758 143.257 137.715 143.493C139.768 143.599 144.531 143.923 146.416 142.134C142.586 143.537 137.829 143.337 134.034 142.443Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M147.087 139.324C145.319 138.165 143.071 137.395 141.368 136.617C137.054 134.649 131.099 132.543 126.352 133.863C130.137 134.742 134.176 136.329 137.974 137.532C140.048 138.191 142.122 139.137 144.093 140.032C144.468 140.203 145.7 140.96 146.913 141.611C146.947 141.559 146.991 141.525 147.02 141.466C147.338 140.815 147.323 140.084 147.087 139.324Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.785 131.805C126.582 131.103 128.669 130.994 130.546 131.144C133.944 131.429 136.721 132.796 139.765 133.95C137.95 131.354 134.18 130.651 131.279 130.397C129.664 130.26 128.028 130.109 126.408 130.26C125.451 130.34 124.132 130.667 123.328 131.199C123.001 131.409 122.34 131.683 122.48 132.202C122.732 133.092 124.383 131.966 124.785 131.805Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.707 155.765C144.307 155.612 150.853 155.461 151.963 152.373C153.088 149.248 147.875 145.175 145.575 143.774C141.585 141.334 135.625 140.883 131.057 140.966C125.41 141.088 117.7 142.815 123.458 149.645C127.191 154.071 136.097 156.078 141.707 155.765Z",
    fill: "url(#paint23_linear_637_1031)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M134.21 151.532C129.082 150.824 124.084 148.506 121.714 144.217C121.102 145.506 121.452 147.261 123.459 149.641C127.19 154.068 136.098 156.077 141.708 155.761C144.202 155.616 150.284 155.442 151.757 152.696C147.798 153.733 141.62 152.556 134.21 151.532Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M137.427 155.018C131.047 154.222 125.823 152.423 122.745 147.283C122.424 146.76 121.6 145.546 121.475 145.051C121.32 146.238 121.851 147.729 123.456 149.643C127.187 154.069 136.095 156.079 141.705 155.763C144.033 155.633 149.444 155.428 151.352 153.18C147.209 155.236 141.827 155.571 137.427 155.018Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M151.777 149.945C149.653 148.845 147.017 148.244 145.01 147.569C139.913 145.874 132.944 144.212 127.762 146.268C132.13 146.807 136.867 148.109 141.292 149.014C143.722 149.512 146.166 150.321 148.497 151.099C148.93 151.244 150.413 151.957 151.857 152.543C151.886 152.481 151.948 152.421 151.963 152.372C152.243 151.599 152.129 150.775 151.777 149.945Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.742 144.133C127.671 143.122 130.02 142.751 132.149 142.707C136.014 142.616 139.317 143.824 142.874 144.755C140.517 142.056 136.185 141.703 132.888 141.776C131.047 141.812 129.191 141.833 127.384 142.188C126.313 142.401 124.869 142.927 124.031 143.622C123.681 143.894 122.968 144.291 123.197 144.854C123.578 145.831 125.297 144.369 125.742 144.133Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.743 168.421C150.362 167.817 157.024 166.53 157.634 163.175C158.235 159.801 152.215 156.537 149.628 155.507C145.127 153.7 138.954 154.27 134.311 155.157C128.555 156.252 120.975 159.337 128.032 165.327C132.618 169.201 142.063 169.722 147.743 168.421Z",
    fill: "url(#paint24_linear_637_1031)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M139.35 165.394C133.999 165.55 128.485 164.059 125.324 160.094C124.923 161.512 125.581 163.239 128.036 165.327C132.62 169.201 142.062 169.722 147.745 168.42C150.26 167.842 156.448 166.613 157.477 163.553C153.607 165.293 147.081 165.163 139.35 165.394Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M143.245 168.394C136.577 168.679 130.941 167.751 126.901 163.039C126.484 162.554 125.439 161.455 125.227 160.973C125.265 162.215 126.067 163.649 128.034 165.324C132.618 169.198 142.06 169.719 147.743 168.417C150.089 167.878 155.588 166.747 157.151 164.11C153.27 166.926 147.821 168.199 143.245 168.394Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M157.02 160.734C154.651 159.982 151.866 159.824 149.696 159.487C144.2 158.631 136.796 158.139 131.859 161.128C136.409 160.931 141.467 161.447 146.16 161.6C148.708 161.688 151.348 162.093 153.87 162.482C154.337 162.56 155.975 163.029 157.554 163.379C157.578 163.312 157.627 163.252 157.635 163.177C157.782 162.347 157.526 161.523 157.02 160.734Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.423 159.305C131.218 157.929 133.548 157.156 135.726 156.733C139.656 155.973 143.234 156.637 147.027 156.974C144.154 154.625 139.677 155.019 136.312 155.66C134.443 156.01 132.553 156.362 130.761 157.034C129.711 157.436 128.322 158.229 127.58 159.077C127.277 159.42 126.613 159.949 126.94 160.488C127.51 161.406 129.003 159.617 129.423 159.305Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.462 179.78C157.985 178.33 164.459 174.887 164.026 171.236C163.585 167.561 156.328 166.094 153.334 165.837C148.113 165.399 141.921 167.932 137.395 170.315C131.805 173.266 124.945 178.851 134.133 182.803C140.083 185.357 150.008 182.917 155.462 179.78Z",
    fill: "url(#paint25_linear_637_1031)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M145.826 179.301C140.353 181.16 134.183 181.347 129.672 178.259C129.711 179.843 130.932 181.425 134.131 182.802C140.084 185.356 150.008 182.913 155.463 179.778C157.882 178.389 163.881 175.15 163.979 171.67C160.536 174.691 153.754 176.625 145.826 179.301Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M150.811 181.181C144.021 183.579 137.892 184.396 132.235 180.805C131.65 180.439 130.213 179.633 129.855 179.195C130.281 180.455 131.567 181.692 134.131 182.802C140.083 185.356 150.007 182.913 155.462 179.778C157.718 178.479 163.03 175.564 163.823 172.359C160.702 176.488 155.478 179.527 150.811 181.181Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M162.617 168.907C159.942 168.881 157.002 169.599 154.658 169.934C148.708 170.787 140.905 172.618 136.746 177.272C141.389 175.628 146.779 174.547 151.666 173.237C154.339 172.519 157.183 172.109 159.911 171.71C160.427 171.635 162.26 171.604 163.999 171.477C163.999 171.396 164.028 171.324 164.022 171.235C163.919 170.333 163.392 169.555 162.617 168.907Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.663 176.146C135.084 174.17 137.246 172.622 139.359 171.505C143.175 169.482 147.077 169.034 151.119 168.18C147.401 166.658 142.9 168.484 139.623 170.206C137.793 171.162 135.96 172.114 134.327 173.382C133.36 174.129 132.185 175.384 131.685 176.494C131.475 176.945 130.964 177.699 131.459 178.143C132.349 178.929 133.326 176.605 133.663 176.146Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.331 189.103C166.34 187.005 171.582 181.884 170.146 178.5C168.678 175.095 161.3 175.733 158.35 176.332C153.224 177.385 148 181.557 144.329 185.128C139.789 189.538 134.793 196.817 144.718 198.023C151.147 198.796 159.975 193.656 164.331 189.103Z",
    fill: "url(#paint26_linear_637_1031)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M154.959 191.37C150.225 194.692 144.361 196.608 139.16 194.92C139.635 196.437 141.265 197.596 144.721 198.024C151.148 198.796 159.976 193.657 164.334 189.104C166.26 187.089 171.108 182.302 170.222 178.934C167.764 182.797 161.806 186.562 154.959 191.37Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M160.262 191.76C154.423 195.981 148.777 198.497 142.337 196.643C141.673 196.445 140.071 196.082 139.602 195.774C140.369 196.866 141.94 197.682 144.722 198.027C151.149 198.8 159.977 193.661 164.335 189.107C166.134 187.227 170.419 182.943 170.269 179.635C168.431 184.479 164.275 188.869 160.262 191.76Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M168.131 176.654C165.559 177.386 162.941 178.91 160.787 179.888C155.319 182.385 148.347 186.332 145.672 191.977C149.659 189.088 154.528 186.536 158.842 183.904C161.201 182.452 163.825 181.265 166.327 180.116C166.801 179.903 168.549 179.351 170.185 178.726C170.151 178.654 170.169 178.568 170.146 178.501C169.775 177.658 169.059 177.067 168.131 176.654Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.383 191.764C143.194 189.461 144.825 187.376 146.541 185.704C149.642 182.691 153.261 181.156 156.888 179.211C152.901 178.793 149.095 181.812 146.435 184.387C144.957 185.818 143.459 187.252 142.243 188.93C141.525 189.915 140.757 191.445 140.597 192.653C140.519 193.151 140.241 194.009 140.843 194.308C141.908 194.808 142.199 192.303 142.383 191.764Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.01 197.443C175.732 195.093 180.289 189.345 178.418 186.176C176.533 182.979 169.294 184.566 166.45 185.533C161.496 187.226 156.842 192.039 153.669 196.042C149.726 200.99 145.705 208.849 155.689 208.787C162.183 208.735 170.274 202.502 174.01 197.443Z",
    fill: "url(#paint27_linear_637_1031)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M164.996 200.887C160.734 204.787 155.165 207.434 149.785 206.412C150.464 207.862 152.22 208.808 155.691 208.79C162.183 208.736 170.274 202.502 174.013 197.446C175.664 195.195 179.861 189.825 178.55 186.594C176.616 190.743 171.174 195.236 164.996 200.887Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M170.313 200.593C165.058 205.52 159.777 208.725 153.155 207.714C152.476 207.613 150.84 207.447 150.324 207.2C151.229 208.186 152.901 208.803 155.688 208.785C162.18 208.73 170.271 202.497 174.01 197.44C175.558 195.34 179.255 190.54 178.684 187.283C177.489 192.316 173.924 197.202 170.313 200.593Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M176.196 184.609C173.727 185.667 171.327 187.498 169.323 188.753C164.21 191.924 157.804 196.74 155.867 202.67C159.463 199.296 163.953 196.146 167.902 192.98C170.059 191.245 172.501 189.72 174.837 188.266C175.275 187.991 176.945 187.223 178.48 186.399C178.454 186.329 178.448 186.243 178.415 186.181C177.943 185.392 177.163 184.892 176.196 184.609Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.581 202.89C153.097 200.494 154.448 198.209 155.936 196.34C158.629 192.943 162.021 190.967 165.375 188.561C161.357 188.667 157.968 192.142 155.664 195.038C154.375 196.646 153.066 198.264 152.086 200.081C151.508 201.15 150.924 202.776 150.917 203.992C150.917 204.484 150.74 205.387 151.386 205.597C152.498 205.957 152.469 203.434 152.581 202.89Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.96 204.263C184.953 201.533 187.696 194.718 185.026 192.216C182.317 189.688 175.812 193.237 173.357 194.975C169.087 197.996 165.984 203.916 164.052 208.653C161.67 214.513 160.023 223.203 169.59 220.314C175.796 218.434 181.806 210.18 183.96 204.263Z",
    fill: "url(#paint28_linear_637_1031)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M176.288 210.106C173.299 215.059 168.702 219.169 163.25 219.709C164.308 220.901 166.263 221.316 169.594 220.315C175.801 218.435 181.81 210.182 183.962 204.267C184.924 201.643 187.441 195.303 185.276 192.58C184.582 197.113 180.638 202.95 176.288 210.106Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M181.313 208.324C177.65 214.534 173.486 219.114 166.857 220.003C166.175 220.104 164.56 220.394 163.992 220.309C165.141 221.004 166.914 221.123 169.59 220.314C175.796 218.434 181.806 210.18 183.958 204.266C184.852 201.82 187.053 196.168 185.591 193.201C185.855 198.369 183.815 204.069 181.313 208.324Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M182.445 191.34C180.373 193.041 178.595 195.476 177.013 197.242C173.005 201.728 168.211 208.156 168.035 214.402C170.521 210.145 173.957 205.853 176.847 201.704C178.431 199.43 180.347 197.278 182.18 195.224C182.522 194.83 183.904 193.632 185.146 192.408C185.102 192.349 185.074 192.266 185.022 192.214C184.342 191.591 183.453 191.34 182.445 191.34Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.939 215.523C164.763 213.09 165.411 210.518 166.311 208.309C167.926 204.29 170.635 201.437 173.171 198.186C169.354 199.407 167.078 203.704 165.681 207.137C164.908 209.037 164.107 210.967 163.669 212.979C163.412 214.169 163.327 215.891 163.658 217.068C163.791 217.543 163.876 218.445 164.555 218.463C165.73 218.492 164.978 216.08 164.939 215.523Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.77 123.961C149.717 125.737 147.195 130.288 144.597 129.943C141.997 129.585 141.037 124.409 140.897 122.28C140.649 118.57 142.513 114.195 144.273 111.011C146.435 107.067 150.477 102.267 153.171 108.838C154.923 113.103 153.062 120.12 150.77 123.961Z",
    fill: "url(#paint29_linear_637_1031)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M150.546 117.112C151.936 113.246 152.141 108.869 149.999 105.625C151.127 105.674 152.232 106.561 153.173 108.846C154.925 113.111 153.064 120.125 150.772 123.966C149.753 125.669 147.391 129.896 144.918 129.919C147.106 127.516 148.555 122.718 150.546 117.112Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M151.82 120.676C153.609 115.878 154.273 111.53 151.779 107.477C151.519 107.057 150.965 106.033 150.664 105.758C151.564 106.079 152.432 107.002 153.171 108.841C154.924 113.107 153.062 120.121 150.77 123.961C149.827 125.548 147.688 129.295 145.398 129.816C148.372 127.648 150.599 123.971 151.82 120.676Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M142.973 128.917C142.98 127.014 143.525 124.934 143.789 123.277C144.474 119.056 145.858 113.53 149.221 110.631C147.989 113.916 147.165 117.731 146.174 121.192C145.627 123.07 145.303 125.103 144.992 127.029C144.927 127.39 144.889 128.699 144.764 129.928C144.72 129.928 144.66 129.949 144.598 129.941C143.96 129.856 143.424 129.477 142.973 128.917Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.448 108.425C147.027 109.421 145.907 110.933 145.085 112.416C143.592 115.11 143.234 117.882 142.576 120.732C141.544 118.079 142.902 114.905 144.16 112.597C144.862 111.316 145.56 110.017 146.472 108.871C147.017 108.192 147.924 107.378 148.712 107.038C149.036 106.893 149.583 106.532 149.894 106.895C150.439 107.533 148.78 108.197 148.448 108.425Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.023 134.981C155.483 136.685 151.752 141.106 149.019 140.165C146.258 139.213 146.333 133.376 146.637 131.016C147.168 126.927 150.144 122.573 152.734 119.488C155.934 115.66 161.368 111.309 162.892 119.044C163.883 124.057 160.349 131.302 157.023 134.981Z",
    fill: "url(#paint30_linear_637_1031)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M158.262 127.473C160.596 123.563 161.773 118.849 160.134 114.848C161.358 115.141 162.366 116.352 162.895 119.043C163.883 124.056 160.349 131.301 157.026 134.98C155.55 136.616 152.069 140.703 149.367 140.197C152.263 138.048 154.876 133.144 158.262 127.473Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M158.874 131.626C161.853 126.787 163.507 122.205 161.674 117.253C161.485 116.739 161.101 115.5 160.826 115.145C161.731 115.694 162.475 116.887 162.893 119.042C163.88 124.054 160.347 131.299 157.023 134.979C155.644 136.509 152.525 140.123 149.922 140.196C153.616 138.472 156.826 134.958 158.874 131.626Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M147.461 138.7C147.881 136.628 148.923 134.476 149.579 132.731C151.22 128.286 153.927 122.574 158.202 120.146C156.164 123.447 154.44 127.423 152.615 130.972C151.622 132.907 150.824 135.038 150.072 137.071C149.926 137.463 149.597 138.873 149.206 140.183C149.151 140.17 149.081 140.183 149.024 140.167C148.342 139.926 147.834 139.395 147.461 138.7Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.844 117.57C156.081 118.343 154.531 119.756 153.333 121.195C151.124 123.801 150.134 126.739 148.814 129.708C148.249 126.594 150.411 123.425 152.275 121.185C153.323 119.945 154.36 118.677 155.599 117.63C156.346 117.015 157.502 116.312 158.438 116.11C158.822 116.03 159.488 115.757 159.744 116.219C160.216 117.025 158.254 117.391 157.844 117.57Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.975 145.725C162.028 147.47 157.304 152.005 154.325 150.615C151.323 149.215 152.111 142.649 152.731 140.023C153.812 135.474 157.693 130.926 160.983 127.758C165.043 123.827 171.708 119.566 172.502 128.471C173.002 134.24 168.146 141.978 163.975 145.725Z",
    fill: "url(#paint31_linear_637_1031)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M166.257 137.421C169.363 133.298 171.242 128.117 169.881 123.408C171.224 123.891 172.222 125.369 172.502 128.472C173.003 134.242 168.147 141.98 163.976 145.727C162.114 147.396 157.696 151.587 154.715 150.703C158.236 148.623 161.764 143.403 166.257 137.421Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M166.457 142.169C170.382 137.079 172.793 132.11 171.328 126.304C171.17 125.705 170.893 124.266 170.623 123.828C171.58 124.554 172.262 125.98 172.497 128.47C172.998 134.239 168.142 141.977 163.97 145.724C162.226 147.285 158.277 150.993 155.34 150.754C159.716 149.253 163.75 145.675 166.457 142.169Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M152.734 148.769C153.465 146.487 154.894 144.2 155.838 142.305C158.22 137.479 161.951 131.367 167.071 129.143C164.372 132.625 161.951 136.906 159.472 140.679C158.119 142.746 156.971 145.056 155.877 147.258C155.674 147.67 155.13 149.221 154.531 150.657C154.466 150.639 154.388 150.644 154.326 150.613C153.585 150.268 153.087 149.612 152.734 148.769Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.977 126.202C164.898 126.86 162.985 128.266 161.447 129.752C158.652 132.425 157.188 135.612 155.344 138.804C155.09 135.226 157.893 131.917 160.27 129.612C161.585 128.336 162.92 127.031 164.442 126.002C165.344 125.39 166.736 124.747 167.827 124.625C168.26 124.576 169.043 124.353 169.279 124.905C169.699 125.87 167.464 126.054 166.977 126.202Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.543 158.338C167.277 159.775 161.653 163.597 158.856 161.657C156.028 159.71 157.975 153.131 159.053 150.567C160.948 146.109 165.7 142.129 169.61 139.455C174.44 136.144 181.974 132.952 181.233 142.176C180.758 148.158 174.474 155.224 169.543 158.338Z",
    fill: "url(#paint32_linear_637_1031)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M173.321 150.251C177.202 146.563 180.028 141.592 179.44 136.557C180.731 137.278 181.493 138.963 181.231 142.176C180.757 148.155 174.47 155.221 169.541 158.333C167.363 159.713 162.126 163.229 159.23 161.81C163.192 160.291 167.7 155.577 173.321 150.251Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M172.708 155.135C177.6 150.615 180.916 145.95 180.426 139.769C180.377 139.131 180.333 137.609 180.138 137.121C180.984 138.021 181.445 139.603 181.235 142.178C180.761 148.157 174.474 155.223 169.545 158.335C167.51 159.621 162.83 162.725 159.867 161.975C164.586 161.208 169.335 158.249 172.708 155.135Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M157.555 159.5C158.688 157.296 160.544 155.198 161.835 153.427C165.107 148.923 169.968 143.317 175.581 141.93C172.218 145.018 169.016 148.97 165.825 152.403C164.085 154.283 162.519 156.435 161.026 158.497C160.738 158.888 159.917 160.379 159.056 161.733C158.988 161.704 158.911 161.702 158.856 161.655C158.159 161.178 157.762 160.418 157.555 159.5Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.002 138.915C173.76 139.232 171.566 140.328 169.728 141.573C166.417 143.824 164.367 146.837 161.93 149.77C162.287 146.069 165.728 143.173 168.541 141.231C170.117 140.152 171.698 139.058 173.433 138.264C174.467 137.798 176.01 137.375 177.127 137.45C177.584 137.479 178.424 137.375 178.579 137.982C178.838 139.042 176.51 138.84 176.002 138.915Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.315 168.189C174.689 169.428 168.153 172.768 165.418 170.331C162.644 167.86 165.596 161.071 167.1 158.462C169.719 153.935 175.334 150.292 179.882 147.945C185.5 145.041 193.998 142.614 191.991 152.405C190.69 158.753 183.006 165.497 177.315 168.189Z",
    fill: "url(#paint33_linear_637_1031)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M182.439 160.011C187.084 156.575 190.766 151.622 190.807 146.148C192.093 147.087 192.692 148.993 191.992 152.405C190.688 158.753 183.006 165.498 177.316 168.189C174.796 169.372 168.714 172.45 165.805 170.536C170.251 169.434 175.7 164.982 182.439 160.011Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M181.127 165.163C186.971 160.96 191.152 156.409 191.43 149.714C191.461 149.021 191.622 147.385 191.474 146.838C192.272 147.911 192.555 149.67 191.992 152.405C190.688 158.753 183.007 165.497 177.316 168.189C174.964 169.291 169.536 172.003 166.453 170.803C171.618 170.601 177.106 168.054 181.127 165.163Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M164.305 167.842C165.816 165.632 168.082 163.628 169.695 161.901C173.796 157.498 179.759 152.141 185.958 151.396C181.952 154.259 177.988 158.066 174.118 161.33C172.002 163.112 170.032 165.215 168.155 167.235C167.805 167.6 166.729 169.091 165.614 170.44C165.567 170.396 165.474 170.383 165.417 170.333C164.732 169.727 164.406 168.848 164.305 167.842Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.805 148.213C184.365 148.249 181.866 149.136 179.738 150.233C175.88 152.211 173.29 155.167 170.285 157.983C171.159 154.068 175.227 151.42 178.519 149.714C180.337 148.768 182.182 147.803 184.155 147.186C185.309 146.812 187.012 146.563 188.213 146.789C188.703 146.885 189.615 146.885 189.698 147.554C189.825 148.721 187.36 148.205 186.805 148.213Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.061 178.532C181.189 178.973 173.989 180.348 172.032 177.233C170.079 174.091 174.819 168.404 176.996 166.327C180.789 162.723 187.203 160.812 192.22 159.837C198.429 158.633 207.272 158.701 202.585 167.53C199.547 173.256 190.276 177.56 184.061 178.532Z",
    fill: "url(#paint34_linear_637_1031)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M191.275 172.135C196.706 170.154 201.624 166.436 203.221 161.195C204.18 162.463 204.217 164.452 202.583 167.535C199.545 173.261 190.274 177.563 184.062 178.535C181.306 178.96 174.604 180.2 172.344 177.552C176.933 177.747 183.414 175.011 191.275 172.135Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M188.564 176.7C195.354 174.322 200.648 171.128 202.813 164.783C203.038 164.129 203.65 162.599 203.663 162.039C204.117 163.286 203.889 165.057 202.582 167.529C199.544 173.254 190.273 177.556 184.061 178.528C181.489 178.93 175.523 179.999 172.902 177.984C177.919 179.244 183.892 178.339 188.564 176.7Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M171.677 174.538C173.743 172.84 176.488 171.564 178.521 170.356C183.691 167.293 190.929 163.831 197.079 164.861C192.428 166.479 187.556 169.023 182.928 171.051C180.385 172.171 177.914 173.633 175.54 175.031C175.088 175.288 173.644 176.431 172.2 177.401C172.156 177.341 172.078 177.305 172.034 177.235C171.557 176.465 171.485 175.542 171.677 174.538Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.792 162.044C196.435 161.393 193.788 161.541 191.439 161.989C187.182 162.803 183.861 164.906 180.18 166.763C182.132 163.252 186.78 161.857 190.413 161.146C192.43 160.752 194.47 160.34 196.536 160.304C197.75 160.286 199.453 160.524 200.547 161.071C200.99 161.305 201.859 161.564 201.745 162.23C201.553 163.389 199.331 162.191 198.792 162.044Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.077 189.052C188.171 189.127 180.839 189.571 179.32 186.226C177.772 182.855 183.204 177.824 185.628 176.04C189.846 172.944 196.457 171.873 201.559 171.549C207.869 171.15 216.619 172.348 210.853 180.508C207.11 185.795 197.367 188.873 191.077 189.052Z",
    fill: "url(#paint35_linear_637_1031)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M199.041 183.633C204.685 182.357 210.051 179.3 212.294 174.303C213.09 175.682 212.864 177.663 210.855 180.51C207.111 185.795 197.366 188.873 191.076 189.055C188.289 189.119 181.486 189.501 179.586 186.591C184.102 187.364 190.884 185.474 199.041 183.633Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M195.774 187.823C202.815 186.327 208.477 183.835 211.427 177.825C211.731 177.197 212.527 175.758 212.628 175.203C212.916 176.51 212.464 178.227 210.852 180.511C207.108 185.796 197.363 188.874 191.073 189.055C188.475 189.12 182.409 189.413 180.078 187.082C184.887 188.983 190.928 188.848 195.774 187.823Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M179.302 183.506C181.571 182.085 184.451 181.167 186.626 180.236C192.143 177.858 199.771 175.345 205.734 177.15C200.911 178.167 195.757 180.062 190.904 181.483C188.252 182.266 185.602 183.399 183.072 184.491C182.595 184.693 181.011 185.637 179.455 186.418C179.416 186.348 179.346 186.306 179.321 186.228C178.942 185.393 178.986 184.473 179.302 183.506Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.795 174.588C205.542 173.639 202.898 173.442 200.505 173.592C196.185 173.851 192.626 175.514 188.742 176.888C191.117 173.649 195.908 172.871 199.595 172.62C201.645 172.487 203.725 172.347 205.773 172.57C206.989 172.703 208.648 173.162 209.654 173.849C210.056 174.126 210.888 174.502 210.701 175.143C210.359 176.271 208.308 174.798 207.795 174.588Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.844 213.254C207.347 210.508 211.259 207.334 216.055 204.126C222.731 199.684 230.206 196.321 235.86 190.479C241.514 184.647 247.208 178.559 252.395 172.227C264.557 157.381 273.758 139.539 281.863 122.251C282.594 122.157 282.988 121.75 282.334 124.976C279.773 137.539 272.939 151.736 266.626 162.809C252.087 188.361 229.425 204.261 205.792 219.171C205.156 217.032 204.148 215.056 202.844 213.254Z",
    fill: "#AD611C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.844 213.254C207.347 210.508 211.259 207.334 216.055 204.126C222.731 199.684 230.206 196.321 235.86 190.479C241.514 184.647 247.208 178.559 252.395 172.227C264.557 157.381 273.758 139.539 281.863 122.251C282.594 122.157 282.988 121.75 282.334 124.976C282.174 125.801 281.935 126.649 281.728 127.484C281.629 127.642 281.526 127.777 281.443 127.958C270.948 152.366 262.838 166.69 247.158 185.213C238.263 195.709 230.802 199.389 225.998 202.983C224.562 204.051 223.157 205.145 221.757 206.253C216.149 209.86 210.419 212.974 204.661 216.225C204.148 215.183 203.528 214.195 202.844 213.254Z",
    fill: "#CE7125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.694 212.401C206.318 213.026 205.009 213.763 203.736 214.569C203.461 214.115 203.155 213.68 202.844 213.255C207.347 210.508 211.259 207.335 216.055 204.127C222.731 199.685 230.206 196.322 235.86 190.48C241.514 184.648 247.208 178.56 252.395 172.227C264.557 157.382 273.758 139.539 281.863 122.251C282.534 122.174 282.931 121.847 282.443 124.401C282.054 124.795 281.707 125.27 281.437 125.892C270.59 150.928 256.271 178.435 234.271 195.578C233.975 195.808 233.742 196.05 233.519 196.304C229.568 198.92 226.055 202.097 221.829 204.353C217.505 206.655 213.113 208.789 208.934 211.336C208.405 211.647 208.021 212.007 207.694 212.401Z",
    fill: "#874315"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.079 116.125C279.77 118.163 278.816 123.287 281.036 124.669C283.281 126.051 287.31 122.667 288.772 121.106C291.326 118.407 292.666 113.848 293.332 110.267C294.17 105.851 294.105 99.5709 287.841 102.929C283.781 105.099 280.753 111.699 280.079 116.125Z",
    fill: "url(#paint36_linear_637_1031)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M284.602 110.982C286 107.113 288.626 103.597 292.341 102.461C291.447 101.779 290.029 101.758 287.841 102.93C283.781 105.101 280.755 111.703 280.081 116.126C279.783 118.087 278.92 122.85 280.817 124.445C280.659 121.193 282.596 116.567 284.602 110.982Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M281.361 112.916C283.033 108.082 285.299 104.307 289.792 102.756C290.254 102.595 291.332 102.16 291.731 102.141C290.845 101.817 289.587 101.986 287.837 102.925C283.777 105.095 280.752 111.697 280.078 116.121C279.803 117.951 279.061 122.191 280.498 124.05C279.593 120.49 280.212 116.245 281.361 112.916Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M282.949 124.917C284.15 123.442 285.054 121.484 285.9 120.045C288.057 116.355 290.504 111.197 289.76 106.828C288.617 110.145 286.823 113.612 285.391 116.912C284.606 118.712 283.574 120.481 282.591 122.163C282.407 122.49 281.606 123.522 280.914 124.554C280.95 124.58 280.974 124.637 281.031 124.671C281.586 125.005 282.247 125.057 282.949 124.917Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.751 105.605C292.223 107.281 292.127 109.163 291.81 110.828C291.245 113.854 289.762 116.224 288.445 118.84C290.942 117.45 291.909 114.139 292.404 111.554C292.682 110.123 292.967 108.676 292.987 107.203C293.006 106.339 292.835 105.133 292.43 104.358C292.267 104.047 292.083 103.422 291.606 103.513C290.789 103.653 291.645 105.227 291.751 105.605Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.679 131.636C286.649 132.041 281.573 133.228 280.103 131.068C278.618 128.895 281.814 124.715 283.305 123.173C285.895 120.507 290.388 118.961 293.919 118.132C298.293 117.087 304.567 116.866 301.502 123.274C299.514 127.43 293.071 130.76 288.679 131.636Z",
    fill: "url(#paint37_linear_637_1031)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M293.612 126.881C297.408 125.309 300.791 122.529 301.761 118.754C302.489 119.628 302.572 121.044 301.502 123.276C299.516 127.43 293.073 130.76 288.679 131.639C286.732 132.023 282.021 133.104 280.328 131.284C283.59 131.284 288.114 129.152 293.612 126.881Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M291.815 130.209C296.57 128.318 300.236 125.891 301.579 121.322C301.716 120.853 302.102 119.753 302.102 119.352C302.473 120.223 302.354 121.488 301.498 123.275C299.512 127.429 293.07 130.758 288.675 131.637C286.858 132 282.661 132.929 280.727 131.575C284.338 132.319 288.548 131.51 291.815 130.209Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M279.762 129.163C281.183 127.9 283.086 126.91 284.507 125.992C288.085 123.666 293.114 120.998 297.514 121.542C294.255 122.828 290.872 124.776 287.646 126.355C285.886 127.229 284.165 128.333 282.531 129.404C282.218 129.601 281.219 130.442 280.232 131.181C280.185 131.142 280.136 131.113 280.105 131.067C279.742 130.53 279.653 129.871 279.762 129.163Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.647 119.493C296.962 119.102 295.075 119.283 293.431 119.675C290.434 120.377 288.142 121.964 285.578 123.393C286.856 120.849 290.11 119.719 292.682 119.107C294.105 118.762 295.536 118.407 296.998 118.324C297.862 118.272 299.072 118.396 299.863 118.752C300.182 118.902 300.817 119.06 300.75 119.54C300.646 120.37 299.034 119.584 298.647 119.493Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.208 143.491C282.916 143.602 277.15 144.071 275.882 141.465C274.617 138.841 278.807 134.778 280.684 133.331C283.958 130.824 289.151 129.867 293.164 129.53C298.124 129.099 305.062 129.9 300.641 136.43C297.792 140.651 290.157 143.255 285.208 143.491Z",
    fill: "url(#paint38_linear_637_1031)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M291.386 139.08C295.814 137.983 299.991 135.486 301.668 131.508C302.327 132.579 302.181 134.153 300.641 136.424C297.79 140.648 290.155 143.252 285.205 143.488C283.009 143.594 277.648 144.004 276.105 141.737C279.668 142.274 284.985 140.677 291.386 139.08Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M288.885 142.443C294.409 141.151 298.83 139.082 301.052 134.295C301.28 133.8 301.894 132.659 301.954 132.221C302.2 133.242 301.876 134.604 300.645 136.429C297.793 140.653 290.158 143.257 285.208 143.493C283.15 143.599 278.387 143.923 276.5 142.134C280.321 143.537 285.089 143.337 288.885 142.443Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M275.829 139.324C277.594 138.165 279.842 137.395 281.54 136.617C285.851 134.649 291.817 132.543 296.559 133.863C292.776 134.742 288.737 136.329 284.936 137.532C282.865 138.191 280.788 139.137 278.82 140.032C278.439 140.203 277.21 140.96 276 141.611C275.966 141.559 275.919 141.525 275.883 141.466C275.58 140.815 275.6 140.084 275.829 139.324Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.122 131.805C296.338 131.103 294.243 130.994 292.372 131.144C288.973 131.429 286.191 132.796 283.152 133.95C284.978 131.354 288.739 130.651 291.646 130.397C293.263 130.26 294.894 130.109 296.512 130.26C297.468 130.34 298.786 130.667 299.597 131.199C299.916 131.409 300.58 131.683 300.434 132.202C300.18 133.092 298.537 131.966 298.122 131.805Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.206 155.765C278.606 155.612 272.054 155.461 270.945 152.373C269.825 149.248 275.041 145.175 277.333 143.774C281.32 141.334 287.283 140.883 291.848 140.966C297.5 141.088 305.2 142.815 299.452 149.645C295.722 154.071 286.816 156.078 281.206 155.765Z",
    fill: "url(#paint39_linear_637_1031)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M288.701 151.532C293.824 150.824 298.831 148.506 301.198 144.217C301.804 145.506 301.457 147.261 299.453 149.641C295.722 154.068 286.819 156.077 281.206 155.761C278.712 155.616 272.63 155.442 271.152 152.696C275.116 153.733 281.297 152.556 288.701 151.532Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M285.478 155.018C291.861 154.222 297.09 152.423 300.162 147.283C300.486 146.76 301.313 145.546 301.428 145.051C301.599 146.238 301.059 147.729 299.452 149.643C295.721 154.069 286.818 156.079 281.206 155.763C278.875 155.633 273.469 155.428 271.559 153.18C275.702 155.236 281.084 155.571 285.478 155.018Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M271.138 149.945C273.261 148.845 275.898 148.244 277.902 147.569C283.004 145.874 289.962 144.212 295.142 146.268C290.781 146.807 286.04 148.109 281.617 149.014C279.19 149.512 276.745 150.321 274.412 151.099C273.974 151.244 272.491 151.957 271.047 152.543C271.021 152.481 270.959 152.421 270.943 152.372C270.666 151.599 270.782 150.775 271.138 149.945Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.172 144.133C295.233 143.122 292.897 142.751 290.763 142.707C286.898 142.616 283.587 143.824 280.035 144.755C282.389 142.056 286.727 141.703 290.024 141.776C291.86 141.812 293.724 141.833 295.526 142.188C296.594 142.401 298.038 142.927 298.886 143.622C299.228 143.894 299.938 144.291 299.718 144.854C299.334 145.831 297.621 144.369 297.172 144.133Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.171 168.421C272.552 167.817 265.887 166.53 265.285 163.175C264.676 159.801 270.698 156.537 273.286 155.507C277.784 153.7 283.952 154.27 288.608 155.157C294.366 156.252 301.936 159.337 294.882 165.327C290.291 169.201 280.854 169.722 275.171 168.421Z",
    fill: "url(#paint40_linear_637_1031)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M283.57 165.394C288.926 165.55 294.433 164.059 297.593 160.094C297.995 161.512 297.342 163.239 294.881 165.327C290.29 169.201 280.855 169.722 275.17 168.42C272.658 167.842 266.475 166.613 265.438 163.553C269.313 165.293 275.834 165.163 283.57 165.394Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M279.666 168.394C286.336 168.679 291.975 167.751 296.012 163.039C296.429 162.554 297.474 161.455 297.692 160.973C297.645 162.215 296.847 163.649 294.881 165.324C290.29 169.198 280.856 169.719 275.17 168.417C272.824 167.878 267.333 166.747 265.77 164.11C269.651 166.926 275.09 168.199 279.666 168.394Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M265.892 160.734C268.264 159.982 271.053 159.824 273.223 159.487C278.722 158.631 286.124 158.139 291.063 161.128C286.508 160.931 281.447 161.447 276.765 161.6C274.216 161.688 271.572 162.093 269.047 162.482C268.58 162.56 266.942 163.029 265.365 163.379C265.342 163.312 265.295 163.252 265.285 163.177C265.135 162.347 265.391 161.523 265.892 160.734Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.495 159.305C291.694 157.929 289.373 157.156 287.195 156.733C283.273 155.973 279.69 156.637 275.887 156.974C278.759 154.625 283.239 155.019 286.604 155.66C288.479 156.01 290.361 156.362 292.16 157.034C293.208 157.436 294.589 158.229 295.336 159.077C295.637 159.42 296.298 159.949 295.982 160.488C295.404 161.406 293.913 159.617 293.495 159.305Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.458 179.78C264.925 178.33 258.454 174.887 258.892 171.236C259.338 167.561 266.584 166.094 269.589 165.837C274.795 165.399 280.989 167.932 285.521 170.315C291.113 173.266 297.965 178.851 288.787 182.803C282.835 185.357 272.905 182.917 267.458 179.78Z",
    fill: "url(#paint41_linear_637_1031)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M277.085 179.301C282.553 181.16 288.721 181.347 293.24 178.259C293.201 179.843 291.98 181.425 288.783 182.802C282.831 185.356 272.904 182.913 267.454 179.778C265.03 178.389 259.028 175.15 258.93 171.67C262.373 174.691 269.15 176.625 277.085 179.301Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M272.106 181.181C278.891 183.579 285.019 184.396 290.682 180.805C291.265 180.439 292.693 179.633 293.069 179.195C292.636 180.455 291.348 181.692 288.789 182.802C282.836 185.356 272.91 182.913 267.46 179.778C265.197 178.479 259.877 175.564 259.094 172.359C262.213 176.488 267.434 179.527 272.106 181.181Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M260.292 168.907C262.978 168.881 265.91 169.599 268.246 169.934C274.198 170.787 282.012 172.618 286.165 177.272C281.53 175.628 276.132 174.547 271.253 173.237C268.578 172.519 265.731 172.109 263.006 171.71C262.488 171.635 260.657 171.604 258.918 171.477C258.918 171.396 258.879 171.324 258.894 171.235C258.995 170.333 259.524 169.555 260.292 168.907Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.258 176.146C287.827 174.17 285.67 172.622 283.557 171.505C279.743 169.482 275.834 169.034 271.797 168.18C275.512 166.658 280.008 168.484 283.285 170.206C285.115 171.162 286.958 172.114 288.589 173.382C289.553 174.129 290.725 175.384 291.236 176.494C291.436 176.945 291.941 177.699 291.454 178.143C290.557 178.929 289.587 176.605 289.258 176.146Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.58 189.103C256.573 187.005 251.333 181.884 252.775 178.5C254.234 175.095 261.613 175.733 264.561 176.332C269.681 177.385 274.923 181.557 278.584 185.128C283.118 189.538 288.119 196.817 278.195 198.023C271.765 198.796 262.935 193.656 258.58 189.103Z",
    fill: "url(#paint42_linear_637_1031)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M267.958 191.372C272.694 194.694 278.561 196.61 283.762 194.922C283.287 196.439 281.657 197.598 278.198 198.026C271.769 198.798 262.938 193.659 258.583 189.105C256.659 187.091 251.808 182.304 252.693 178.936C255.155 182.799 261.111 186.564 267.958 191.372Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M262.655 191.76C268.498 195.981 274.14 198.497 280.582 196.643C281.241 196.445 282.848 196.082 283.323 195.774C282.55 196.866 280.976 197.682 278.197 198.027C271.768 198.8 262.937 193.661 258.582 189.107C256.783 187.227 252.497 182.943 252.653 179.635C254.491 184.479 258.634 188.869 262.655 191.76Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M254.777 176.654C257.354 177.386 259.97 178.91 262.125 179.888C267.595 182.385 274.574 186.332 277.244 191.977C273.257 189.088 268.386 186.536 264.077 183.904C261.707 182.452 259.094 181.265 256.587 180.116C256.118 179.903 254.365 179.351 252.734 178.726C252.758 178.654 252.747 178.568 252.776 178.501C253.139 177.658 253.86 177.067 254.777 176.654Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.533 191.764C279.716 189.461 278.085 187.376 276.377 185.704C273.279 182.691 269.657 181.156 266.027 179.211C270.017 178.793 273.815 181.812 276.488 184.387C277.964 185.818 279.465 187.252 280.67 188.93C281.388 189.915 282.158 191.445 282.327 192.653C282.397 193.151 282.679 194.009 282.07 194.308C281.01 194.808 280.717 192.303 280.533 191.764Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.907 197.445C247.175 195.095 242.628 189.346 244.497 186.178C246.385 182.981 253.621 184.567 256.467 185.535C261.416 187.228 266.065 192.041 269.246 196.044C273.189 200.992 277.208 208.851 267.216 208.789C260.737 208.737 252.646 202.504 248.907 197.445Z",
    fill: "url(#paint43_linear_637_1031)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M257.918 200.889C262.182 204.789 267.754 207.436 273.128 206.414C272.449 207.864 270.696 208.81 267.217 208.792C260.738 208.738 252.647 202.504 248.908 197.448C247.257 195.197 243.057 189.827 244.366 186.596C246.305 190.745 251.739 195.238 257.918 200.889Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M252.611 200.595C257.861 205.522 263.134 208.727 269.761 207.716C270.432 207.615 272.076 207.449 272.579 207.202C271.684 208.188 270.012 208.805 267.215 208.787C260.736 208.732 252.645 202.499 248.906 197.442C247.353 195.342 243.659 190.542 244.232 187.285C245.432 192.318 248.986 197.204 252.611 200.595Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M246.722 184.611C249.187 185.669 251.588 187.5 253.589 188.755C258.704 191.926 265.111 196.742 267.047 202.672C263.451 199.298 258.961 196.148 255.01 192.982C252.856 191.247 250.413 189.722 248.072 188.268C247.634 187.993 245.962 187.225 244.43 186.401C244.458 186.331 244.458 186.245 244.492 186.183C244.964 185.394 245.754 184.894 246.722 184.611Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.332 202.892C269.821 200.496 268.46 198.211 266.977 196.342C264.291 192.945 260.895 190.969 257.543 188.562C261.556 188.669 264.945 192.143 267.262 195.04C268.538 196.648 269.847 198.266 270.835 200.083C271.413 201.152 271.991 202.778 271.997 203.994C271.999 204.486 272.175 205.389 271.527 205.599C270.415 205.959 270.446 203.436 270.332 202.892Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.95 204.267C237.957 201.537 235.217 194.722 237.898 192.22C240.597 189.691 247.099 193.241 249.562 194.979C253.826 198 256.943 203.92 258.869 208.657C261.246 214.517 262.898 223.207 253.329 220.318C247.117 218.438 241.105 210.184 238.95 204.267Z",
    fill: "url(#paint44_linear_637_1031)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M246.623 210.11C249.62 215.063 254.214 219.173 259.666 219.712C258.611 220.905 256.656 221.32 253.325 220.319C247.118 218.439 241.106 210.186 238.952 204.271C237.998 201.647 235.475 195.307 237.648 192.584C238.34 197.117 242.283 202.954 246.623 210.11Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M241.606 208.328C245.262 214.538 249.415 219.117 256.057 220.007C256.739 220.108 258.357 220.398 258.922 220.313C257.771 221.008 256.003 221.127 253.324 220.318C247.118 218.438 241.106 210.184 238.951 204.27C238.065 201.824 235.863 196.172 237.323 193.205C237.056 198.373 239.102 204.073 241.606 208.328Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M240.467 191.344C242.544 193.045 244.314 195.48 245.896 197.246C249.904 201.732 254.695 208.16 254.877 214.406C252.388 210.149 248.955 205.857 246.064 201.708C244.48 199.434 242.564 197.282 240.734 195.228C240.392 194.834 239.013 193.636 237.766 192.412C237.815 192.352 237.838 192.269 237.895 192.218C238.559 191.595 239.461 191.344 240.467 191.344Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.968 215.527C258.145 213.094 257.499 210.522 256.605 208.313C254.987 204.293 252.28 201.441 249.742 198.189C253.564 199.411 255.835 203.707 257.232 207.141C258.007 209.041 258.803 210.971 259.241 212.983C259.503 214.173 259.591 215.895 259.257 217.072C259.125 217.547 259.034 218.449 258.365 218.467C257.18 218.496 257.935 216.084 257.968 215.527Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.147 123.961C273.21 125.737 275.722 130.288 278.328 129.943C280.921 129.585 281.882 124.409 282.022 122.28C282.271 118.57 280.402 114.195 278.649 111.011C276.487 107.067 272.443 102.267 269.754 108.838C267.989 113.103 269.853 120.12 272.147 123.961Z",
    fill: "url(#paint45_linear_637_1031)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M272.376 117.112C270.982 113.246 270.777 108.869 272.923 105.625C271.791 105.674 270.681 106.561 269.753 108.846C267.99 113.111 269.854 120.125 272.146 123.966C273.157 125.669 275.532 129.896 278 129.919C275.809 127.516 274.36 122.718 272.376 117.112Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M271.091 120.676C269.315 115.878 268.648 111.53 271.142 107.477C271.399 107.057 271.959 106.033 272.255 105.758C271.355 106.079 270.492 107.002 269.753 108.841C267.99 113.107 269.854 120.121 272.146 123.961C273.095 125.548 275.226 129.295 277.515 129.816C274.541 127.648 272.317 123.971 271.091 120.676Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M279.95 128.917C279.94 127.014 279.392 124.934 279.128 123.277C278.449 119.056 277.057 113.53 273.699 110.631C274.931 113.916 275.76 117.731 276.745 121.192C277.287 123.07 277.614 125.103 277.923 127.029C277.982 127.39 278.029 128.699 278.158 129.928C278.203 129.928 278.254 129.949 278.327 129.941C278.954 129.856 279.491 129.477 279.95 128.917Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.468 108.425C275.891 109.421 277.016 110.933 277.828 112.416C279.332 115.11 279.684 117.882 280.337 120.732C281.375 118.079 280.019 114.905 278.756 112.597C278.053 111.316 277.351 110.017 276.443 108.871C275.902 108.192 274.992 107.378 274.198 107.038C273.877 106.893 273.335 106.532 273.021 106.895C272.482 107.533 274.136 108.197 274.468 108.425Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.888 134.981C267.426 136.685 271.154 141.106 273.886 140.165C276.647 139.213 276.575 133.376 276.277 131.016C275.745 126.927 272.764 122.573 270.174 119.488C266.975 115.66 261.538 111.309 260.021 119.044C259.028 124.057 262.575 131.302 265.888 134.981Z",
    fill: "url(#paint46_linear_637_1031)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M264.654 127.473C262.316 123.563 261.136 118.849 262.775 114.848C261.559 115.141 260.545 116.352 260.021 119.043C259.028 124.056 262.572 131.301 265.888 134.98C267.364 136.616 270.848 140.703 273.544 140.197C270.651 138.048 268.035 133.144 264.654 127.473Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M264.037 131.626C261.058 126.787 259.404 122.205 261.24 117.253C261.424 116.739 261.81 115.5 262.082 115.145C261.18 115.694 260.441 116.887 260.021 119.042C259.028 124.054 262.572 131.299 265.888 134.979C267.27 136.509 270.381 140.123 272.989 140.196C269.295 138.472 266.083 134.958 264.037 131.626Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M275.457 138.7C275.032 136.628 273.992 134.476 273.339 132.731C271.69 128.286 268.989 122.574 264.719 120.146C266.754 123.447 268.478 127.423 270.301 130.972C271.288 132.907 272.092 135.038 272.839 137.071C272.992 137.463 273.316 138.873 273.71 140.183C273.764 140.17 273.832 140.183 273.886 140.167C274.576 139.926 275.081 139.395 275.457 138.7Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.068 117.57C266.833 118.343 268.373 119.756 269.589 121.195C271.788 123.801 272.775 126.739 274.1 129.708C274.663 126.594 272.508 123.425 270.631 121.185C269.594 119.945 268.555 118.677 267.308 117.63C266.566 117.015 265.413 116.312 264.479 116.11C264.088 116.03 263.427 115.757 263.17 116.219C262.701 117.025 264.653 117.391 265.068 117.57Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.948 145.725C260.874 147.47 265.611 152.005 268.587 150.615C271.584 149.215 270.804 142.649 270.177 140.023C269.106 135.474 265.222 130.926 261.93 127.758C257.864 123.827 251.207 119.566 250.416 128.471C249.905 134.24 254.764 141.978 258.948 145.725Z",
    fill: "url(#paint47_linear_637_1031)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M256.656 137.421C253.548 133.298 251.668 128.117 253.029 123.408C251.692 123.891 250.693 125.369 250.416 128.472C249.905 134.242 254.766 141.98 258.948 145.727C260.799 147.396 265.225 151.587 268.196 150.703C264.675 148.623 261.149 143.403 256.656 137.421Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M256.457 142.169C252.526 137.079 250.118 132.11 251.583 126.304C251.738 125.705 252.013 124.266 252.28 123.828C251.331 124.554 250.642 125.98 250.416 128.47C249.905 134.239 254.766 141.977 258.948 145.724C260.675 147.285 264.626 150.993 267.574 150.754C263.197 149.253 259.163 145.675 256.457 142.169Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M270.173 148.771C269.442 146.489 268.016 144.202 267.075 142.307C264.684 137.481 260.959 131.369 255.836 129.145C258.54 132.627 260.959 136.908 263.437 140.681C264.801 142.748 265.942 145.058 267.033 147.26C267.23 147.672 267.78 149.222 268.371 150.659C268.446 150.641 268.524 150.646 268.584 150.615C269.325 150.27 269.825 149.614 270.173 148.771Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.933 126.202C258.01 126.86 259.926 128.266 261.466 129.752C264.255 132.425 265.725 135.612 267.571 138.804C267.825 135.226 265.018 131.917 262.643 129.612C261.323 128.336 259.993 127.031 258.471 126.002C257.561 125.39 256.166 124.747 255.083 124.625C254.65 124.576 253.867 124.353 253.621 124.905C253.208 125.87 255.454 126.054 255.933 126.202Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.367 158.338C255.641 159.775 261.264 163.597 264.061 161.657C266.88 159.71 264.94 153.131 263.862 150.567C261.961 146.109 257.214 142.129 253.305 139.455C248.47 136.144 240.938 132.952 241.68 142.176C242.154 148.158 248.444 155.224 253.367 158.338Z",
    fill: "url(#paint48_linear_637_1031)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M249.586 150.251C245.702 146.563 242.884 141.592 243.464 136.557C242.173 137.278 241.416 138.963 241.676 142.176C242.15 148.155 248.44 155.221 253.363 158.333C255.548 159.713 260.775 163.229 263.671 161.81C259.707 160.291 255.211 155.577 249.586 150.251Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M250.206 155.135C245.314 150.615 241.991 145.95 242.488 139.769C242.54 139.131 242.584 137.609 242.779 137.121C241.928 138.021 241.469 139.603 241.679 142.178C242.154 148.157 248.443 155.223 253.367 158.335C255.41 159.621 260.087 162.725 263.047 161.975C258.321 161.208 253.577 158.249 250.206 155.135Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M265.357 159.5C264.224 157.296 262.365 155.198 261.071 153.427C257.805 148.923 252.946 143.317 247.328 141.93C250.691 145.018 253.895 148.97 257.081 152.403C258.826 154.283 260.392 156.435 261.891 158.497C262.176 158.888 262.998 160.379 263.851 161.733C263.915 161.704 263.998 161.702 264.061 161.655C264.748 161.178 265.155 160.418 265.357 159.5Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.915 138.915C249.155 139.232 251.348 140.328 253.184 141.573C256.495 143.824 258.54 146.837 260.985 149.77C260.625 146.069 257.182 143.173 254.364 141.231C252.787 140.152 251.206 139.058 249.471 138.264C248.445 137.798 246.9 137.375 245.782 137.45C245.316 137.479 244.478 137.375 244.333 137.982C244.071 139.042 246.399 138.84 246.915 138.915Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.605 168.189C248.229 169.428 254.762 172.768 257.495 170.331C260.266 167.86 257.318 161.071 255.82 158.462C253.196 153.935 247.576 150.292 243.036 147.945C237.413 145.041 228.917 142.614 230.926 152.405C232.225 158.753 239.912 165.497 245.605 168.189Z",
    fill: "url(#paint49_linear_637_1031)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M240.484 160.011C235.823 156.575 232.152 151.622 232.108 146.148C230.819 147.087 230.22 148.993 230.923 152.405C232.224 158.753 239.909 165.498 245.602 168.189C248.114 169.372 254.199 172.45 257.113 170.536C252.669 169.434 247.217 164.982 240.484 160.011Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M241.797 165.163C235.948 160.96 231.766 156.409 231.486 149.714C231.452 149.021 231.289 147.385 231.444 146.838C230.643 147.911 230.366 149.67 230.929 152.405C232.23 158.753 239.914 165.497 245.608 168.189C247.959 169.291 253.378 172.003 256.471 170.803C251.304 170.601 245.82 168.054 241.797 165.163Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M258.61 167.842C257.106 165.632 254.833 163.628 253.215 161.901C249.116 157.498 243.158 152.141 236.957 151.396C240.965 154.259 244.927 158.066 248.8 161.33C250.915 163.112 252.878 165.215 254.76 167.235C255.11 167.6 256.181 169.091 257.304 170.44C257.353 170.396 257.441 170.383 257.493 170.333C258.182 169.727 258.512 168.848 258.61 167.842Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.106 148.213C238.545 148.249 241.052 149.136 243.176 150.233C247.026 152.211 249.616 155.167 252.62 157.983C251.757 154.068 247.679 151.42 244.397 149.714C242.569 148.768 240.733 147.803 238.763 147.186C237.607 146.812 235.901 146.563 234.708 146.789C234.213 146.885 233.311 146.885 233.22 147.554C233.085 148.721 235.553 148.205 236.106 148.213Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.857 178.534C241.732 178.975 248.934 180.35 250.889 177.235C252.844 174.092 248.102 168.406 245.922 166.329C242.139 162.725 235.715 160.813 230.698 159.838C224.494 158.635 215.64 158.703 220.338 167.532C223.366 173.258 232.642 177.562 238.857 178.534Z",
    fill: "url(#paint50_linear_637_1031)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M231.648 172.137C226.214 170.156 221.296 166.438 219.702 161.197C218.743 162.465 218.706 164.454 220.337 167.537C223.365 173.263 232.644 177.565 238.856 178.537C241.614 178.962 248.319 180.202 250.569 177.554C245.988 177.749 239.507 175.013 231.648 172.137Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M234.357 176.702C227.56 174.324 222.263 171.13 220.111 164.784C219.878 164.131 219.274 162.601 219.25 162.041C218.799 163.288 219.03 165.059 220.337 167.531C223.365 173.256 232.644 177.558 238.855 178.53C241.427 178.932 247.395 180 250.019 177.986C244.997 179.246 239.026 178.341 234.357 176.702Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M251.251 174.54C249.169 172.842 246.434 171.566 244.396 170.358C239.229 167.295 231.993 163.833 225.836 164.863C230.492 166.481 235.366 169.025 239.997 171.052C242.532 172.173 245.005 173.635 247.378 175.033C247.829 175.29 249.283 176.433 250.722 177.403C250.769 177.343 250.841 177.307 250.888 177.237C251.365 176.467 251.435 175.544 251.251 174.54Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.128 162.046C226.482 161.395 229.124 161.543 231.476 161.991C235.73 162.805 239.051 164.908 242.728 166.765C240.786 163.254 236.129 161.859 232.505 161.148C230.488 160.754 228.44 160.342 226.387 160.306C225.171 160.287 223.46 160.526 222.371 161.073C221.933 161.307 221.059 161.566 221.165 162.232C221.362 163.391 223.587 162.193 224.128 162.046Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.833 189.052C234.737 189.127 242.066 189.571 243.59 186.226C245.133 182.855 239.706 177.824 237.277 176.04C233.062 172.944 226.453 171.873 221.351 171.549C215.028 171.15 206.288 172.348 212.054 180.508C215.795 185.795 225.543 188.873 231.833 189.052Z",
    fill: "url(#paint51_linear_637_1031)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M223.871 183.633C218.224 182.357 212.868 179.3 210.623 174.303C209.827 175.682 210.055 177.663 212.059 180.51C215.797 185.795 225.548 188.873 231.838 189.055C234.632 189.119 241.427 189.501 243.333 186.591C238.812 187.364 232.022 185.474 223.871 183.633Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M227.135 187.823C220.094 186.327 214.426 183.835 211.486 177.825C211.175 177.197 210.382 175.758 210.281 175.203C209.993 176.51 210.441 178.227 212.054 180.511C215.792 185.796 225.543 188.874 231.833 189.055C234.433 189.12 240.497 189.413 242.833 187.082C238.026 188.983 231.978 188.848 227.135 187.823Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M243.606 183.506C241.332 182.085 238.457 181.167 236.284 180.236C230.757 177.858 223.143 175.345 217.172 177.15C221.997 178.167 227.148 180.062 232.004 181.483C234.656 182.266 237.306 183.399 239.839 184.491C240.308 184.693 241.897 185.637 243.455 186.418C243.484 186.348 243.559 186.306 243.588 186.228C243.974 185.393 243.922 184.473 243.606 183.506Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.113 174.588C217.371 173.639 220.016 173.442 222.403 173.592C226.725 173.851 230.282 175.514 234.171 176.888C231.796 173.649 227.003 172.871 223.313 172.62C221.255 172.487 219.186 172.347 217.138 172.57C215.919 172.703 214.263 173.162 213.254 173.849C212.85 174.126 212.02 174.502 212.217 175.143C212.549 176.271 214.6 174.798 215.113 174.588Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.867 545.574C302.867 551.334 297.954 556.001 291.898 556.001H131.006C124.944 556.001 120.039 551.334 120.039 545.574V531.292C120.039 525.543 124.944 520.873 131.006 520.873H291.898C297.951 520.873 302.867 525.543 302.867 531.292V545.574Z",
    fill: "#993E00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.898 520.873H131.006C124.944 520.873 120.039 525.543 120.039 531.292V545.574C120.039 549.531 122.383 552.931 125.8 554.699C125.512 549.801 125.922 545.014 130.464 542.1C136.992 537.927 204.357 539.654 211.448 539.582C226.389 539.411 281.398 538.231 286.969 541.475C294.034 545.598 294.125 552.379 291.996 555.986C298.019 555.939 302.864 551.3 302.864 545.577V531.295C302.867 525.543 297.954 520.873 291.898 520.873Z",
    fill: "#7A3100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.713 524.633L294.402 508.772C292.396 502.771 285.831 498.34 279.775 498.34H212.495H210.416H143.126C137.065 498.34 130.513 502.771 128.512 508.772L121.201 524.633C116.524 533.896 126.114 535.052 132.175 535.052H210.872H212.044H290.752C296.8 535.052 306.388 533.896 301.713 524.633Z",
    fill: "url(#paint52_linear_637_1031)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M159.502 514.565C176.221 525.857 208.377 524.553 223.375 524.799C249.687 525.206 284.437 510.369 292.482 505.157C289.55 501.083 284.531 498.34 279.776 498.34H158.856C154.985 502.421 150.819 508.694 159.502 514.565Z",
    fill: "#7A3100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.135 531.851C262.276 531.988 163.118 531.63 140.153 532.603C133.71 532.875 122.318 532.654 120.664 525.855C117.444 533.974 126.391 535.05 132.173 535.05H290.75C296.243 535.05 304.63 534.065 302.621 526.955C300.684 532.055 293.446 531.819 289.135 531.851Z",
    fill: "#FFAC48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.722 496.79C279.055 481.141 256.466 477.401 243.786 475.724C231.795 474.132 213.442 475.547 211.448 475.708C209.483 475.547 191.12 474.132 179.124 475.724C166.452 477.401 143.863 481.143 142.191 496.79C139.733 519.704 207.103 520.41 211.257 520.436C211.257 520.436 211.422 520.436 211.448 520.436C211.487 520.436 211.664 520.436 211.664 520.436C215.814 520.412 283.18 519.704 280.722 496.79Z",
    fill: "url(#paint53_linear_637_1031)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M176.377 498.662C173.805 498.293 171.285 497.78 168.898 496.937C165.691 495.804 161.61 493.18 158.092 494.344C154.797 495.431 154.633 498.776 156.264 501.387C158.439 504.862 163.181 505.357 166.699 506.716C173.162 509.202 179.221 509.594 185.993 510.595C190.022 511.194 194.997 511.946 198.844 509.941C203.571 507.46 198.754 502.188 195.422 501.148C191.362 499.883 186.322 499.699 181.964 499.289C180.111 499.11 178.231 498.929 176.377 498.662Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M280.723 496.79C280.601 495.618 280.326 494.484 279.945 493.401C279.925 493.362 279.906 493.32 279.899 493.284C279.152 491.233 277.952 489.363 276.489 487.667C276.342 487.512 276.222 487.343 276.085 487.188C276.028 487.136 275.971 487.086 275.922 487.032C268.232 479.383 253.255 476.979 243.789 475.724C231.799 474.132 213.446 475.547 211.452 475.708C209.487 475.547 191.124 474.132 179.128 475.724C173.235 476.504 165.201 477.749 158.118 480.417C158.665 482.121 159.674 483.817 160.902 485.378C163.778 488.998 168.343 491.069 172.784 492.47C180.305 494.85 188.529 494.946 196.244 496.014C201.756 496.772 207.312 497.129 212.834 497.884C219.412 498.781 226.575 498.042 231.267 503.806C234.773 508.119 231.524 511.752 227.166 513.38C219.632 516.191 211.52 517 203.54 517.018C199.293 517.028 194.691 517.135 190.494 516.507C183.543 515.475 176.442 514.464 169.549 513.1C163.511 511.899 157.138 510.261 152.028 506.68C145.915 502.406 145.718 497.005 144.435 490.323C143.9 491.186 143.473 492.122 143.097 493.092C143.048 493.224 142.988 493.356 142.944 493.486C142.578 494.526 142.319 495.618 142.195 496.79C139.737 519.704 207.107 520.41 211.26 520.436C211.26 520.436 211.426 520.436 211.452 520.436C211.491 520.436 211.668 520.436 211.668 520.436C215.816 520.412 283.181 519.704 280.723 496.79Z",
    fill: "#C96C06"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M278.349 504.647C281.877 486.625 259.205 478.61 238.776 476.471C234.534 475.529 224.434 481.574 221.242 481.483C233.803 487.128 256.67 495.021 247.658 507.616C242.96 514.2 232.753 517.272 225.453 519.559C224.973 519.705 224.498 519.839 224.016 519.987C240.959 518.968 269.912 515.597 278.349 504.647Z",
    fill: "#C96C06"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M232.299 479.211C231.99 479.211 268.924 485.46 258.409 504.563C255.974 508.997 251.282 515.278 246.636 517.502C256.06 515.944 265.458 513.556 271.981 509.848C284.326 487.638 248.116 479.211 232.299 479.211Z",
    fill: "#BC5E00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.026 504.33C171.849 505.365 177.41 507.631 179.191 505.254C181.784 501.805 175.212 499.8 171.087 499.334C165.586 498.722 162.581 501.942 169.026 504.33Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.82 209.248C243.82 227.117 229.335 241.627 211.454 241.627C193.584 241.627 179.094 227.117 179.094 209.248C179.094 191.358 193.584 176.863 211.454 176.863C229.332 176.863 243.82 191.361 243.82 209.248Z",
    fill: "url(#paint54_linear_637_1031)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M211.453 176.863C209.988 176.863 208.552 176.996 207.124 177.19C223.496 176.863 250.394 194.864 236.705 221.495C227.859 238.697 209.734 239.364 199.299 235.142C186.684 230.029 182.551 220.058 179.168 210.744C179.959 227.923 194.091 241.627 211.456 241.627C229.337 241.627 243.821 227.117 243.821 209.248C243.819 191.361 229.332 176.863 211.453 176.863Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M231.687 183.992C246.955 199.369 245.547 222.968 230.264 233.193C206.557 249.049 188.65 231.626 186.449 229.71C192.381 236.966 201.354 241.625 211.457 241.625C229.338 241.625 243.823 227.115 243.823 209.246C243.82 199.019 239.083 189.922 231.687 183.992Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.16 215.4C180.347 204.356 183.308 195.77 190.044 188.45C200.73 176.831 218.891 179.014 225.271 185.865C225.271 185.865 204.217 180.762 193.326 192.2C181.141 205.007 187.964 221.328 193.162 228.139C193.162 228.139 185.675 225.248 183.16 215.4Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.046 192.012C192.889 191.097 193.762 190.244 194.758 189.502C195.748 188.779 196.959 188.338 197.799 187.428C198.618 186.551 198.867 185.322 197.34 185.18C195.261 184.975 193.14 186.847 191.779 188.18C190.12 189.798 188.448 191.543 187.286 193.56C186.41 195.106 184.585 197.359 185.132 199.257C186.005 202.174 188.927 196.099 189.262 195.469C189.806 194.432 190.488 193.814 191.227 192.941C191.499 192.627 191.776 192.316 192.046 192.012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.777 184.496C199.541 186.244 202.94 185.222 203.772 184.957C204.335 184.778 205.694 184.592 206.129 184.19C207.06 183.308 205.748 182.346 204.947 182.139C203.656 181.799 200.379 182.691 199.876 184.089C199.821 184.242 199.795 184.374 199.777 184.496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.351 205.985C185.721 205.104 185.698 203.828 185.167 203.374C183.676 202.057 183.025 204.995 183.162 205.76C183.264 206.4 183.761 207.378 184.726 206.789C184.99 206.634 185.198 206.338 185.351 205.985Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.988 193.792C201.873 193.286 203.839 191.396 204.349 186.451H219.176V222.355H226.879V231.441H196.432V222.355H204.207V201.932H195.991L195.988 193.792Z",
    fill: "#7A3100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.744 188.126H219.176V186.451H204.349C203.839 191.396 201.873 193.286 195.988 193.792V201.932H197.383V195.467C203.271 194.962 205.233 193.066 205.744 188.126Z",
    fill: "#512202"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.057 493.806C236.269 493.492 247.274 484.152 247.274 484.152C221.408 461.022 224.512 376.362 224.512 376.362H198.402C198.402 376.362 201.505 461.022 175.637 484.152C175.637 484.152 186.65 493.492 210.849 493.806V493.834C211.064 493.834 211.248 493.824 211.458 493.824C211.66 493.824 211.852 493.834 212.057 493.834V493.806Z",
    fill: "url(#paint55_linear_637_1031)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M185.54 489.385C195.991 474.698 199.46 454.073 201.085 436.99C202.996 416.785 202.501 396.598 202.299 376.362H198.402C198.402 376.362 201.505 461.022 175.637 484.152C175.637 484.152 178.851 486.844 185.54 489.385Z",
    fill: "#D87D05"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M217.573 376.359C217.648 400.397 215.856 423.732 220.855 447.759C223.904 462.404 227.974 476.76 232.262 491.06C242.459 488.203 247.278 484.15 247.278 484.15C221.412 461.02 224.515 376.359 224.515 376.359H217.573Z",
    fill: "#D87D05"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M224.512 376.359H220.2C220.301 392.856 220.848 409.369 222.508 425.783C223.783 438.362 226.951 450.982 227.519 463.6C228.279 480.317 219.703 491.524 201.941 489.722C189.315 488.436 186.085 479.218 186.453 467.728C183.573 474.493 180.031 480.221 175.637 484.15C175.637 484.15 186.65 493.49 210.849 493.804V493.832C211.064 493.832 211.248 493.822 211.458 493.822C211.66 493.822 211.852 493.832 212.057 493.832V493.804C236.269 493.49 247.274 484.15 247.274 484.15C221.406 461.022 224.512 376.359 224.512 376.359Z",
    fill: "#D87D05"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M201.867 452.959C202.352 443.01 203.267 433.097 203.794 423.201C204.139 416.74 202.63 408.52 204.66 402.462C206.402 397.268 208.854 399.786 209.585 403.979C210.664 410.286 210.384 417.072 210.578 423.479C211.014 438.596 211.748 453.96 211.102 469.106C210.926 473.333 210.744 478.698 207.226 481.675C204.932 483.627 199.871 485.256 197.986 482.232C196.109 479.227 198.93 470.667 199.576 467.431C200.522 462.637 201.626 457.86 201.867 452.959Z",
    fill: "#FFD629"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.306 375.795C223.224 376.796 217.59 377.19 211.454 377.491C205.317 377.187 199.681 376.796 193.596 375.795C191.945 375.515 186.021 373.614 186.016 376.148C186.01 379.368 189.114 378.572 192.409 384.565C194.776 388.874 198.38 392.209 203.093 393.778C207.212 395.134 211.342 395.09 211.454 395.09C211.568 395.09 215.695 395.134 219.81 393.778C224.52 392.212 228.124 388.874 230.501 384.565C233.797 378.572 236.9 379.368 236.892 376.148C236.887 373.614 230.966 375.515 229.306 375.795Z",
    fill: "url(#paint56_linear_637_1031)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M229.306 375.795C225.822 376.368 222.47 376.718 219.097 377.001C217.58 385.356 208.408 387.91 200.132 384.97C195.038 383.152 192.85 380.774 192.183 375.479C189.819 374.937 186.021 374.112 186.016 376.145C186.01 379.366 189.114 378.57 192.409 384.562C194.776 388.872 198.38 392.207 203.093 393.776C207.212 395.132 211.342 395.088 211.454 395.088C211.568 395.088 215.695 395.132 219.81 393.776C224.52 392.209 228.124 388.872 230.501 384.562C233.797 378.57 236.9 379.366 236.892 376.145C236.887 373.615 230.966 375.515 229.306 375.795Z",
    fill: "#D87D05"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M229.309 375.795C227.167 376.148 225.109 376.355 223.037 376.581C223.553 383.432 221.08 390.962 213.52 392.126C201.263 394.014 193.604 386.496 191.066 375.243C188.787 374.763 186.016 374.415 186.016 376.148C186.01 379.368 189.114 378.572 192.409 384.565C194.776 388.874 198.38 392.209 203.093 393.778C207.212 395.134 211.342 395.09 211.454 395.09C211.568 395.09 215.695 395.134 219.81 393.778C224.52 392.212 228.124 388.874 230.501 384.565C233.797 378.572 236.9 379.368 236.892 376.148C236.89 373.614 230.968 375.515 229.309 375.795Z",
    fill: "#D87D05"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M220.986 393.247C222.355 392.22 223.672 391.066 224.899 389.674C228.787 385.26 231.523 380.538 232.705 375.072C231.326 375.319 229.967 375.684 229.309 375.796C228.616 375.915 227.942 375.972 227.266 376.052C227.421 383.093 223.6 391.022 215.902 394.696C217.121 394.499 218.451 394.222 219.809 393.778C220.232 393.638 220.59 393.415 220.986 393.247Z",
    fill: "#D87D05"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M236.845 376.496C236.858 376.374 236.892 376.283 236.892 376.146C236.887 373.612 230.963 375.513 229.306 375.793C223.224 376.794 217.59 377.188 211.454 377.489C205.317 377.185 199.681 376.794 193.596 375.793C191.945 375.513 186.021 373.612 186.016 376.146C186.016 376.535 186.117 376.815 186.205 377.11C190.929 380.069 199.725 383.207 211.677 383.232C224.723 383.266 234.808 379.418 236.845 376.496Z",
    fill: "#AD6004"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.825 373.747C236.828 370.954 234.845 373.041 232.467 368.198C228.819 360.737 224.661 358.549 224.661 358.549C221.161 362.514 212.45 361.992 211.522 361.92V361.912C211.522 361.912 211.485 361.912 211.475 361.912C211.46 361.912 211.431 361.912 211.431 361.912V361.92C210.498 361.992 201.792 362.511 198.292 358.549C198.292 358.549 194.131 360.737 190.475 368.198C188.101 373.041 186.12 370.954 186.125 373.747C186.128 377.696 195.484 382.231 211.431 382.249C211.444 382.249 211.454 382.249 211.475 382.249C211.485 382.249 211.498 382.249 211.522 382.249C227.469 382.231 236.82 377.696 236.825 373.747Z",
    fill: "url(#paint57_linear_637_1031)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.366 368.595C197.915 370.503 197.825 372.373 198.156 373.345C199.632 377.683 204.589 375.635 206.074 372.531C207.399 369.741 207.16 365.556 204.596 363.512C201.48 361.031 199.245 364.879 198.366 368.595Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M232.468 368.198C228.821 360.737 224.662 358.549 224.662 358.549C221.375 362.265 213.597 362.044 211.86 361.941C212.609 363.478 213.089 365.187 213.346 366.751C214.193 371.867 211.759 376.941 206.335 378.209C201.363 379.363 195.107 377.006 194.573 371.288C194.166 366.956 196.569 362.744 199.385 359.472C199.001 359.187 198.607 358.904 198.296 358.551C198.296 358.551 194.135 360.74 190.479 368.2C188.104 373.044 186.124 370.957 186.129 373.749C186.132 377.698 195.488 382.234 211.435 382.252H211.526C227.467 382.234 236.821 377.698 236.827 373.749C236.827 370.951 234.843 373.041 232.468 368.198Z",
    fill: "#D87D05"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M232.472 368.198C228.824 360.737 224.666 358.549 224.666 358.549C222.382 361.134 217.912 361.801 214.806 361.941C220.061 367.523 222.213 376.226 213.437 380.478C211.724 381.311 209.961 381.788 208.188 382.13C209.261 382.179 210.29 382.249 211.436 382.249H211.527C227.468 382.231 236.822 377.696 236.828 373.747C236.83 370.951 234.847 373.041 232.472 368.198Z",
    fill: "#D87D05"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M234.032 372.158C232.73 371.173 231.512 370.239 230.962 368.678C228.678 362.209 225.059 360.583 223.61 359.369C221.798 360.759 219.322 361.462 217.012 361.742C222.285 366.715 225.158 371.886 222.583 379.535C222.339 380.259 222.031 380.912 221.689 381.527C228.93 380.461 233.819 378.314 235.813 376.035C235.937 374.64 235.523 373.304 234.032 372.158Z",
    fill: "#D87D05"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M211.071 380.502C203.848 380.32 190.794 379.638 186.76 372.137C186.364 372.422 186.122 372.798 186.125 373.744C186.128 377.694 195.484 382.229 211.431 382.247H211.522C227.464 382.229 236.817 377.694 236.823 373.744C236.823 373.07 236.701 372.692 236.491 372.414C232.076 379.457 217.788 380.668 211.071 380.502Z",
    fill: "#D87D05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.673 369.185C202.645 368.527 203.869 365.34 201.681 365.597C199.962 365.791 199.516 370.643 201.673 369.185Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_637_1031",
    x: 0,
    y: 0,
    width: 422.908,
    height: 580.001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_637_1031"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_637_1031",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_637_1031",
    x1: 16.0067,
    y1: 152.878,
    x2: 191.156,
    y2: 152.878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E89A01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3091,
    stopColor: "#FFBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E28601"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_637_1031",
    x1: 102.122,
    y1: 148.625,
    x2: -105.903,
    y2: -66.752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1369,
    stopColor: "#FFBD10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4977,
    stopColor: "#FFDE2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7983,
    stopColor: "#FFF33D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFA43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_637_1031",
    x1: 406.904,
    y1: 152.878,
    x2: 231.754,
    y2: 152.878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E89A01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3091,
    stopColor: "#FFBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E28601"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_637_1031",
    x1: 320.793,
    y1: 148.628,
    x2: 528.827,
    y2: -66.7576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1369,
    stopColor: "#FFBD10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4977,
    stopColor: "#FFDE2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7983,
    stopColor: "#FFF33D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFA43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_637_1031",
    x1: 175.636,
    y1: 319.269,
    x2: 247.273,
    y2: 319.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E89A01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1091,
    stopColor: "#FFBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E28601"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_637_1031",
    x1: 212.122,
    y1: 230.051,
    x2: 210.795,
    y2: 249.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C26B01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB9200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_637_1031",
    x1: 175.634,
    y1: 256.559,
    x2: 247.272,
    y2: 256.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2424,
    stopColor: "#FFF500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6061,
    stopColor: "#FFE600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8182,
    stopColor: "#FFBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E89A01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_637_1031",
    x1: 107.367,
    y1: 140.409,
    x2: 314.847,
    y2: 140.409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0481,
    stopColor: "#FFBD10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1749,
    stopColor: "#FFDE2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2806,
    stopColor: "#FFF33D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3515,
    stopColor: "#FFFA43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433,
    stopColor: "#FFF13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5642,
    stopColor: "#FFDA28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7278,
    stopColor: "#FFB308"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7636,
    stopColor: "#FFAA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E58800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_637_1031",
    x1: 125.707,
    y1: 14.1316,
    x2: 297.081,
    y2: 53.6889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2242,
    stopColor: "#FB9D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4329,
    stopColor: "#F18E01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7585,
    stopColor: "#E67D02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E27702"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_637_1031",
    x1: 107.364,
    y1: 70.856,
    x2: 314.843,
    y2: 70.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0481,
    stopColor: "#FFBD10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1749,
    stopColor: "#FFDE2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2806,
    stopColor: "#FFF33D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3515,
    stopColor: "#FFFA43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433,
    stopColor: "#FFF13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5642,
    stopColor: "#FFDA28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7278,
    stopColor: "#FFB308"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7636,
    stopColor: "#FFAA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E58800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_637_1031",
    x1: 103.336,
    y1: 56.6527,
    x2: 133.751,
    y2: 64.6882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_637_1031",
    x1: 127.045,
    y1: 90.2396,
    x2: 147.736,
    y2: 66.5315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_637_1031",
    x1: 148.015,
    y1: 72.5815,
    x2: 179.089,
    y2: 77.5105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_637_1031",
    x1: 175.001,
    y1: 103.604,
    x2: 193.193,
    y2: 77.9302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_637_1031",
    x1: 187.735,
    y1: 77.6099,
    x2: 219.194,
    y2: 77.4558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_637_1031",
    x1: 219.375,
    y1: 103.869,
    x2: 233.179,
    y2: 75.595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_637_1031",
    x1: 228.621,
    y1: 77.2344,
    x2: 259.853,
    y2: 73.4345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_637_1031",
    x1: 263.095,
    y1: 99.6445,
    x2: 273.529,
    y2: 69.9618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_637_1031",
    x1: 265.317,
    y1: 71.4617,
    x2: 295.042,
    y2: 61.1686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_637_1031",
    x1: 303.729,
    y1: 86.1045,
    x2: 307.672,
    y2: 54.8925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_637_1031",
    x1: 137.291,
    y1: 102.448,
    x2: 135.246,
    y2: 124.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_637_1031",
    x1: 120.836,
    y1: 125.474,
    x2: 142.955,
    y2: 124.438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_637_1031",
    x1: 121.991,
    y1: 138.926,
    x2: 146.093,
    y2: 134.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_637_1031",
    x1: 123.446,
    y1: 152.495,
    x2: 150.042,
    y2: 144.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_637_1031",
    x1: 128.519,
    y1: 168.243,
    x2: 154.264,
    y2: 155.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_637_1031",
    x1: 135.548,
    y1: 185.665,
    x2: 158.034,
    y2: 164.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_637_1031",
    x1: 146.886,
    y1: 200.367,
    x2: 162.374,
    y2: 173.323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_637_1031",
    x1: 158.149,
    y1: 210.836,
    x2: 170.053,
    y2: 182.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_637_1031",
    x1: 172.517,
    y1: 221.588,
    x2: 175.823,
    y2: 190.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_637_1031",
    x1: 155.19,
    y1: 109.885,
    x2: 139.585,
    y2: 125.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_637_1031",
    x1: 164.861,
    y1: 120.612,
    x2: 144.496,
    y2: 134.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_637_1031",
    x1: 174.529,
    y1: 130.47,
    x2: 149.921,
    y2: 143.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_637_1031",
    x1: 182.965,
    y1: 144.579,
    x2: 155.583,
    y2: 153.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_637_1031",
    x1: 193.527,
    y1: 155.207,
    x2: 162.966,
    y2: 161.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_637_1031",
    x1: 203.269,
    y1: 170.648,
    x2: 172.228,
    y2: 167.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_637_1031",
    x1: 211.131,
    y1: 183.69,
    x2: 180.7,
    y2: 176.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_637_1031",
    x1: 285.622,
    y1: 102.448,
    x2: 287.667,
    y2: 124.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_637_1031",
    x1: 302.078,
    y1: 125.474,
    x2: 279.962,
    y2: 124.438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_637_1031",
    x1: 300.921,
    y1: 138.925,
    x2: 276.819,
    y2: 134.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_637_1031",
    x1: 299.461,
    y1: 152.495,
    x2: 272.868,
    y2: 144.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_637_1031",
    x1: 294.397,
    y1: 168.243,
    x2: 268.653,
    y2: 155.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_637_1031",
    x1: 287.365,
    y1: 185.665,
    x2: 264.881,
    y2: 164.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_637_1031",
    x1: 276.029,
    y1: 200.367,
    x2: 260.541,
    y2: 173.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_637_1031",
    x1: 264.765,
    y1: 210.836,
    x2: 252.862,
    y2: 182.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_637_1031",
    x1: 250.399,
    y1: 221.592,
    x2: 247.093,
    y2: 190.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_637_1031",
    x1: 267.731,
    y1: 109.886,
    x2: 283.335,
    y2: 125.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_637_1031",
    x1: 258.05,
    y1: 120.614,
    x2: 278.413,
    y2: 134.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_637_1031",
    x1: 248.385,
    y1: 130.472,
    x2: 272.989,
    y2: 143.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_637_1031",
    x1: 239.946,
    y1: 144.578,
    x2: 267.33,
    y2: 153.652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_637_1031",
    x1: 229.388,
    y1: 155.207,
    x2: 259.943,
    y2: 161.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_637_1031",
    x1: 219.648,
    y1: 170.65,
    x2: 250.692,
    y2: 167.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_637_1031",
    x1: 211.778,
    y1: 183.689,
    x2: 242.21,
    y2: 176.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_637_1031",
    x1: 211.456,
    y1: 535.051,
    x2: 211.456,
    y2: 498.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1636,
    stopColor: "#E28601"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8242,
    stopColor: "#C4550A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_637_1031",
    x1: 149.867,
    y1: 474.329,
    x2: 273.674,
    y2: 519.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0324,
    stopColor: "#FFBD10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1176,
    stopColor: "#FFDE2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1887,
    stopColor: "#FFF33D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2364,
    stopColor: "#FFFA43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#FFF53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601,
    stopColor: "#FFBF12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7636,
    stopColor: "#FFAA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E58800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_637_1031",
    x1: 191.973,
    y1: 235.102,
    x2: 230.947,
    y2: 183.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E28601"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    stopColor: "#FFE600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6364,
    stopColor: "#FFF500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8909,
    stopColor: "#FFBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E89A01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_637_1031",
    x1: 175.636,
    y1: 435.097,
    x2: 247.273,
    y2: 435.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E89A01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1091,
    stopColor: "#FFBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E28601"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_637_1031",
    x1: 186.017,
    y1: 384.968,
    x2: 236.893,
    y2: 384.968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFF500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_637_1031",
    x1: 186.129,
    y1: 370.398,
    x2: 236.826,
    y2: 370.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFF500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAward2);
export default __webpack_public_path__ + "static/media/Award2.5ad68c470ce5b0a411eabbb40fdda565.svg";
export { ForwardRef as ReactComponent };